import React, { useReducer } from 'react';
//import axios from 'axios';
import * as APIRequest from '../../utils/APIRequest';
import apiCryptography from '../../utils/apiCryptography';
import documentUploadContext from './documentUploadContext';
import documentUploadReducer from './documentUploadReducer';
import { Log, ErrorLog } from '../../logs/Logs.service.jsx';
import moment from 'moment';
import aesjs from 'aes-js';
import JSEncrypt from 'jsencrypt'

import {
    SET_USER_INFO,
    SET_OTP_SUCCESS,
    SET_ERRORS,
    SET_LOADING,
    NEXT_STEP,
    SET_NOTIFICATIONS,
    //GET_DOCUMENT_ITEM,
    GET_COMPLIANCE_DOCUMENTS,
    UPLOAD_DOCUMENT,
    //REMOVE_DOCUMENT,
    ADD_NO_SUBMITTED_DOCUMENTS,
    DONE_PROCESS,
    GET_CUST_ID,
    ADD_NO_DELETED_DOCUMENTS,
    SET_TOKEN,
    GET_APPLICATION_DETAILS,
    GET_VIDEO_CALL_SCHEDULE,
    SET_VIDEO_CALL_SCHEDULE,
    SET_DISPLAY_VIDEO_CALL_SCHEDULE,
    SET_ATM_CARD_NUMBER,
    SET_ATM_CARD_BIRTHDAY,
    NOMINATE_PIN,
    SUBMIT_NOMINATED_PIN,
    ATM_CARD_VALIDATION,
    ATM_CARD_ACTIVATION_SUBMIT,
    SET_NOMINATED_PIN,
    CARD_SESSION_VALIDATION,
    CHANGE_ATM_PIN,
    SET_OLD_PIN,
    SET_LOCAL_IP,
    OLD_PIN_VALIDATION,
    ACTIVATION_CODE_VALIDATION,
    SET_REF_CODE
} from './types';

import { color } from '@material-ui/system';
import { conditionalExpression } from '@babel/types';
import Axios from 'axios';
const os = require('os');


const DocumentUploadState = (props) => {
    const initialState = {
        step: 0,
        userInfo: null,
        customerId: null,
        otp_succ: '',
        errors: null,
        notifications: null,
        isOTPValidate: false,
        loading: false,
        requirements: null,
        documents: [],
        uploadedDocuments: [],
        complianceDocuments: null,
        noOfUploadedDocs: 0,
        noOfRequiredDocs: null,
        noOfSubmittedDocs: 0,
        doneProcess: 0,
        delDocs: false,
        token: null,
        applicationDetails: null,
        videoCallSchedule: null,
        selectedVideoCallSchedule: null,
        selectedDisplayVideoCallSchedule: null,
        atmCardNumberDetails: null,
        atmCardDetailsBirthday: null,
        atmCardValidation: null,
        atmCardActivationSubmit: null,
        changePinSubmit: null,
        setNominatedPin: null,
        setOldPin: null,
        cardSessionValidation: null,
        localIP: '0.0.0.0',
        genericNotif: process.env.REACT_APP_GENERIC_NOTIF,
        oldPinValidation: null,
        activationCodeValidation: null,
        referenceCode: ''
    };

    const formatDate = (Date) => {
        moment.locale('en');
        return moment(Date).format('DD-MM-YYYY');
    };

    const [state, dispatch] = useReducer(documentUploadReducer, initialState);

    const CheckifSoftLock = (failedattemp, locktimeparam) => {
        const logintry = localStorage.getItem(failedattemp);
        var locktime = localStorage.getItem(locktimeparam) || '';
        const curtime = new Date();
        const DiffMins = 1000 * 60;
        const DiffSec = 1000;
        //var localIP = localStorage.getItem('LOCALIP') || '';       
        //if (localIP === '') {
        APIRequest.GETIP().then((result) => {
            var response = result;
            if (!response.length) {
                nextStep(2);
                dispatch({
                    type: SET_ERRORS,
                    payload: 'Account Services is temporarily unavailable. Please try again later.',
                });
            } else {
                dispatch({
                    type: SET_LOCAL_IP,
                    payload: response,
                });
            }

        });
        //} 
        //window.localStorage.setItem('LOCALIP', '120.0.0.1' ); 

        if (locktime !== '') {
            locktime = new Date(locktime);
            if (logintry >= 3 && locktime.getTime() > curtime.getTime()) {
                var locktimeduration = locktime.getTime() - curtime.getTime();
                var minDiff = Math.floor(locktimeduration / DiffMins);
                var secDiff = Math.floor(locktimeduration / DiffSec);
                secDiff = secDiff % 60;

                dispatch({
                    type: SET_ERRORS,
                    payload: 'Please retry after ' + minDiff + 'mins. and ' + secDiff + 'sec/s.',
                });
                return false;
            }
            else {
                localStorage.setItem(failedattemp, 0);
                localStorage.setItem(locktimeparam, '');
                return true;
            }
        }
        else {
            return true;
        }

    }

    function _normalizeFamily(family) {
        return family ? family.toLowerCase() : 'ipv4';
    }

    function isLoopback(addr) {
        return /^(::f{4}:)?127\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})/
            .test(addr) ||
            /^fe80::1$/.test(addr) ||
            /^::1$/.test(addr) ||
            /^::$/.test(addr);
    };

    function isPrivate(addr) {
        return /^(::f{4}:)?10\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})$/i
            .test(addr) ||
            /^(::f{4}:)?192\.168\.([0-9]{1,3})\.([0-9]{1,3})$/i.test(addr) ||
            /^(::f{4}:)?172\.(1[6-9]|2\d|30|31)\.([0-9]{1,3})\.([0-9]{1,3})$/i
                .test(addr) ||
            /^(::f{4}:)?127\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})$/i.test(addr) ||
            /^(::f{4}:)?169\.254\.([0-9]{1,3})\.([0-9]{1,3})$/i.test(addr) ||
            /^f[cd][0-9a-f]{2}:/i.test(addr) ||
            /^fe80:/i.test(addr) ||
            /^::1$/.test(addr) ||
            /^::$/.test(addr);
    };

    function isPublic(addr) {
        return !isPrivate(addr);
    };

    //
    // Default to `ipv4`
    //
    function loopback(family) {
        family = _normalizeFamily(family);

        if (family !== 'ipv4' && family !== 'ipv6') {
            throw new Error('family must be ipv4 or ipv6');
        }

        return family === 'ipv4' ? '127.0.0.1' : 'fe80::1';
    };


    function localIpUrl(name, family) {
        debugger;
        var interfaces = os.networkInterfaces();
        var all;
        //
        // Default to `ipv4`
        //
        family = _normalizeFamily(family);

        //
        // If a specific network interface has been named,
        // return the address.
        //
        if (name && name !== 'private' && name !== 'public') {
            var res = interfaces[name].filter(function (details) {
                var itemFamily = details.family.toLowerCase();
                return itemFamily === family;
            });
            if (res.length === 0)
                return undefined;
            return res[0].address;
        }

        var all = Object.keys(interfaces).map(function (nic) {

            var addresses = interfaces[nic].filter(function (details) {
                details.family = details.family.toLowerCase();
                if (details.family !== family || isLoopback(details.address)) {
                    return false;
                } else if (!name) {
                    return true;
                }

                return name === 'public' ? isPrivate(details.address) : isPublic(details.address);
            });

            return addresses.length ? addresses[0].address : undefined;
        }).filter(Boolean);

        return !all.length ? loopback(family) : all[0];
    }

    const setIncorrectLinkError = () => {
        dispatch({
            type: SET_ERRORS,
            payload: 'You have provided an invalid link. Please click on the button below to go back to our website home page. Thank you.',
        });
    }

    const getApplicationDetails = (linkIdentifier) => {
        setLoading();
        try {
            APIRequest.POST(`api/MW/Callapi`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json',
                },
                APIurl: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/validate/link`,
                APIData: apiCryptography.encrypt(
                    `{Data: 'linkId=${linkIdentifier}'}`
                ),
                APImethod: 'GET',
                APIsystem: 'On-Boarding-Client-Scheduler',
                APIreferenceno: linkIdentifier,
                APIevent: 'Get application details',
            }).then((result) => {
                var response = result;
                if (response.data.error) {
                    nextStep(2);
                    dispatch({
                        type: SET_ERRORS,
                        payload: 'Client scheduler is temporarily unavailable. Please try again later.',
                    });
                }
                else {
                    if (response.data !== '') {
                        response.data = JSON.parse(apiCryptography.decrypt(response.data));
                    }
                }

                if (response.data.data) {
                    let LogItem = {
                        screen: 'On-Boarding-Client-Scheduler',
                        activity: 'Get application details',
                        url: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/validate/link`,
                        changes: '',
                        details: 'Retrieve client details',
                        callingMethodName: 'GET',
                        refno: linkIdentifier.substring(10, 17),
                        ipAdd: window.localStorage.getItem('LOCALIP') || '',
                    };
                    Log(LogItem);

                    var result = response.data.data;

                    dispatch({
                        type: GET_APPLICATION_DETAILS,
                        payload: result,
                    });
                }
                else {
                    let LogItem = {
                        serviceName: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/validate/link`,
                        methodName: 'POST',
                        parameters: apiCryptography.encrypt(`{Data: {linkId: '${linkIdentifier}'}}`),
                        error: `${response.data.errors[0].message}`,
                    };

                    ErrorLog(LogItem);

                    dispatch({
                        type: SET_ERRORS,
                        payload:
                            response.data.errors[0].message ||
                            response.data.errors[0].errorMessage
                    });
                }
            });
        }
        catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload: 'Client scheduler is temporarily unavailable. Please try again later.',
            });
        }
    };

    const getVideoCallSchedule = () => {
        setLoading();
        try {
            APIRequest.POST(`api/MW/Callapi`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json',
                },
                APIurl: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/scheduler/available-slots`,
                APImethod: 'GET',
                APIsystem: 'On-Boarding-Scheduler',
                APIreferenceno: '',
                APIevent: 'Get available schedule',
            }).then(
                (result) => {
                    var res = result;
                    if (res.data.error) {
                        nextStep(2);
                        dispatch({
                            type: SET_ERRORS,
                            payload:
                                'Client scheduler is temporarily unavailable. Please try again later.',
                        });
                    } else {
                        if (res.data !== '') {
                            res.data = JSON.parse(apiCryptography.decrypt(res.data));
                        }
                    }
                    if (res.data.data) {

                        let LogItem = {
                            screen: 'On-Boarding-Client-Scheduler',
                            activity: 'Get available schedule',
                            url: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/scheduler/available-slots`,
                            changes: '',
                            details: '',
                            callingMethodName: 'GET',
                            refno: state.applicationDetails.referenceNumber,
                            ipAdd: window.localStorage.getItem('LOCALIP') || '',
                        };

                        Log(LogItem);

                        var result = res.data.data;

                        dispatch({
                            type: GET_VIDEO_CALL_SCHEDULE,
                            payload: result,
                        });
                    } else if (res.data.errors) {
                        nextStep(2);
                        dispatch({
                            type: SET_ERRORS,
                            payload:
                                'Client scheduler is temporarily unavailable. Please try again later.',
                        });
                        dispatch({
                            type: SET_ERRORS,
                            payload: res.data.errors[0].message,
                        });
                    } else {
                        nextStep(2);
                        dispatch({
                            type: SET_ERRORS,
                            payload:
                                'Client scheduler is temporarily unavailable. Please try again later.',
                        });
                    }
                },
                (error) => {
                    nextStep(2);
                    dispatch({
                        type: SET_ERRORS,
                        payload:
                            'Client scheduler is temporarily unavailable. Please try again later.',
                    });
                }
            );
        } catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload:
                    'Client scheduler is temporarily unavailable. Please try again later.',
            });
        }
    };

    const setVideoCallSchedule = (videoCallSchedule) => {
        setLoading();
        try {
            nextStep(3);
            dispatch({
                type: SET_VIDEO_CALL_SCHEDULE,
                payload: videoCallSchedule,
            });
        } catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload:
                    'Client scheduler is temporarily unavailable. Please try again later.',
            });
        }
    };

    const setDisplayVideoCallSchedule = (displayVideoCallSchedule) => {
        try {
            dispatch({
                type: SET_DISPLAY_VIDEO_CALL_SCHEDULE,
                payload: displayVideoCallSchedule,
            });
        } catch (error) {
            nextStep(2);
            console.log(error);
            dispatch({
                type: SET_ERRORS,
                payload:
                    'Client scheduler is temporarily unavailable. Please try again later.',
            });
        }
    };

    const submitVideoCallSchedule = (referenceNumber, videoCallSchedule) => {
        setLoading();
        try {
            APIRequest.POST(`api/MW/Callapi`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json',
                },
                APIurl: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/scheduler/save`,
                APIdata: apiCryptography.encrypt(`{Data: {systemName: 'P1', referenceNumber: '${referenceNumber}', schedule: '${videoCallSchedule}', interviewAccountID: '0', applicationUsed: 'Webex', createdBy: 'CLIENT'}}`),
                APImethod: 'POST',
                APIsystem: 'On-Boarding-Client-Scheduler',
                APIreferenceno: referenceNumber,
                APIevent: 'Submit selected schedule',
            }).then((result) => {
                var res = result;

                if (res.data.error) {
                    nextStep(2);
                    dispatch({
                        type: SET_ERRORS,
                        payload:
                            'Client scheduler is temporarily unavailable. Please try again later.',
                    });
                } else {
                    if (res.data !== '') {
                        res.data = JSON.parse(apiCryptography.decrypt(res.data));
                    }
                }

                if (res.data.data) {
                    let LogItem = {
                        screen: 'On-Boarding-Client-Scheduler',
                        activity: 'Submit selected schedule',
                        url: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/scheduler/assigned`,
                        changes: '',
                        details: '',
                        callingMethodName: 'POST',
                        refno: referenceNumber,
                        ipAdd: window.localStorage.getItem('LOCALIP') || '',
                    };

                    Log(LogItem);
                    nextStep(4);
                } else {
                    dispatch({
                        type: SET_ERRORS,
                        payload:
                            res.data.errors[0].message ||
                            res.data.errors[0].errorMessage
                    });
                }
            });
        }
        catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload: 'Client scheduler is temporarily unavailable. Please try again later.',
            });
        }
    }

    ////Green Pin////
    const setAtmCardNumberDetails = (cardNumber, activationCode, birthday) => {
        setLoading();
        try {
            dispatch({
                type: SET_ATM_CARD_NUMBER,
                payload: cardNumber,
            });

            var currentURL = window.location.href;

            if (currentURL.toLowerCase().includes("activatecard")) {            
            activationCodeValidation(cardNumber, activationCode)
            }else{
                cardValidation(cardNumber, 4);
            }
        } catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload: state.genericNotif,
            });
        }
    }

    const cardValidation = (cardNumber, platform) => {
        setLoading();
        try {

            APIRequest.POST(`api/MW/Callapi`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json',
                },
                APIurl: `${process.env.REACT_APP_API_LINK}/card/ip-block`,
                APIData: apiCryptography.encrypt(`ipAddress=${window.localStorage.getItem('LOCALIP') || ''}`
                ),
                APImethod: 'GET',
                APIsystem: 'On-Boarding-Activate-Card',
                APIreferenceno: cardNumber,
                APIevent: 'IP Blocking',
            }).then((result) => {
                var response = result;
                if (response.data.error || response.status !== 200) {
                    nextStep(2);
                    dispatch({
                        type: SET_ERRORS,
                        payload: state.genericNotif,
                    });
                }
                else {
                    if (response.data !== '') {
                        response.data = JSON.parse(apiCryptography.decrypt(response.data));
                    }
                }
                //IP Blocking Checking
                if (response.data.data) {
                    var result = response.data.data;
                    if (result.isValid == true) {
                        setLoading();
                        // if (response.status === 200) {
                        //ATM Card Number Validation

                        try {
                            APIRequest.POST(`api/MW/Callapi`, {
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                    Accept: 'application/json',
                                },
                                APIurl: `${process.env.REACT_APP_API_LINK}/card/validation`,
                                APIdata: apiCryptography.encrypt(`{Data: {cardNumber: '${cardNumber}', platform: '${platform}'}}`),
                                APImethod: 'POST',
                                APIsystem: 'ATM-Card-Activation',
                                APIreferenceno: cardNumber,
                                APIevent: 'Submit card number and birthday',
                            }).then((result) => {
                                var res = result;

                                if (res.data.error) {
                                    nextStep(2);
                                    dispatch({
                                        type: SET_ERRORS,
                                        payload:
                                            res.data.errors[0].message ||
                                            res.data.errors[0].errorMessage
                                    });
                                } else {
                                    if (res.data !== '') {
                                        res.data = JSON.parse(apiCryptography.decrypt(res.data));
                                    }
                                }

                                if (res.data.data) {
                                    let LogItem = {
                                        screen: 'ATM-Card-Activation',
                                        activity: 'Submit card number',
                                        url: `${process.env.REACT_APP_API_LINK}/card/validation`,
                                        changes: '',
                                        details: '',
                                        callingMethodName: 'POST',
                                        refno: cardNumber,
                                        ipAdd: window.localStorage.getItem('LOCALIP') || '',
                                    };

                                    Log(LogItem);
                                    var result = res.data.data;

                                    dispatch({
                                        type: ATM_CARD_VALIDATION,
                                        payload: result,
                                    });

                                    dispatch({
                                        type: SET_ATM_CARD_BIRTHDAY,
                                        payload: moment(result.dateOfBirth).format('MM') + moment(result.dateOfBirth).format('DD') + moment(result.dateOfBirth).format('YYYY').toString(),
                                    });

                                    var currentURL = window.location.href;

                                    if (currentURL.toLowerCase().includes("activatecard")) {
                                        if (result.validForInitialPin == true) {
                                            if (result.isJointAccount == true) {
                                                nextStep(7);
                                            }
                                            else {
                                                nextStep(5);
                                            }
                                        }
                                        else {
                                            dispatch({
                                                type: SET_ERRORS,
                                                payload: state.genericNotif
                                            });
                                        }
                                    }
                                    else if (currentURL.toLowerCase().includes("changepin")) {
                                        if (result.validForInitialPin == true) {
                                            dispatch({
                                                type: SET_ERRORS,
                                                payload: result.message
                                            });
                                        }
                                        else {

                                            nextStep(5); /* -1 */
                                            /* if (result.isJointAccount == true) {
                                                nextStep(7);
                                            }
                                            else {
                                                nextStep(5);
                                            } */
                                        }
                                    }

                                } else {
                                    var currentTimeStamp = moment().toDate(); //new Date();

                                    try {
                                        APIRequest.POST(`api/MW/Callapi`, {
                                            headers: {
                                                'Content-Type': 'application/x-www-form-urlencoded',
                                                Accept: 'application/json',
                                            },
                                            APIurl: `${process.env.REACT_APP_API_LINK}/card/ip-block`,
                                            APIdata: apiCryptography.encrypt(`{Data: {ipAddress: '${window.localStorage.getItem('LOCALIP') || ''}', system: 'Green PIN - Corpsite', module: 'Activate ATM Card', action: 'Card Validation', requestTime: '${currentTimeStamp.toISOString()}' }}`),
                                            APImethod: 'POST',
                                            APIsystem: 'ATM-Card-Activation',
                                            APIreferenceno: cardNumber,
                                            APIevent: 'IP Blocking Submit',
                                        }).then((result) => {
                                            var res = result;

                                            if (res.data.error) {
                                                nextStep(2);
                                                dispatch({
                                                    type: SET_ERRORS,
                                                    payload: state.genericNotif,
                                                });
                                            } else {
                                                if (res.data !== '') {
                                                    res.data = JSON.parse(apiCryptography.decrypt(res.data));
                                                }
                                            }

                                            /* if (res.data.data) {
                                                //Nothing happens
                                            } else {
                                                dispatch({
                                                    type: SET_ERRORS,
                                                    payload:
                                                        res.data.errors[0].message ||
                                                        res.data.errors[0].errorMessage
                                                });
                                            } */
                                        });
                                    }
                                    catch (error) {
                                        dispatch({
                                            type: SET_ERRORS,
                                            payload: state.genericNotif,
                                        });
                                    }

                                    dispatch({
                                        type: SET_ERRORS,
                                        payload:
                                            res.data.errors[0].message ||
                                            res.data.errors[0].errorMessage
                                    });
                                }

                            });
                        }
                        catch (error) {
                            nextStep(2);
                            dispatch({
                                type: SET_ERRORS,
                                payload: state.genericNotif,
                            });
                        }
                    }
                    else {
                        dispatch({
                            type: SET_ERRORS,
                            payload: result.message
                        });
                    }
                }
                else {
                    dispatch({
                        type: SET_ERRORS,
                        payload: Boolean(typeof response.data.errors !== "undefined") ?
                            response.data.errors[0].message ||
                            response.data.errors[0].errorMessage :
                            'You have entered an invalid information, please call our 24/7 Customer Experience Hotline at (632) 8845-8888 for assistance'
                    });
                }
            });
        }
        catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload: 'Card Activation is temporarily unavailable. Please try again later.',
            });
        }
    };

    const activationCodeValidation = (cardNumber, activationCode, platform) => {
        setLoading();
        try {
            APIRequest.POST(`api/MW/Callapi`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json',
                },
                APIurl: `${process.env.REACT_APP_API_LINK}/card/reference-code/validate`,
                APIdata: apiCryptography.encrypt(`cardNumber=${cardNumber}&referenceCode=${activationCode}`),
                APImethod: 'GET',
                APIsystem: 'ATM-Card-Activation',
                APIreferenceno: cardNumber,
                APIevent: 'Activation Code validation',
            }).then((result) => {
                debugger;
                var res = result;
                if (res.data.error) {
                    nextStep(2);
                    dispatch({
                        type: SET_ERRORS,
                        payload:
                            res.data.error
                    });
                } else {
                    if (res.data !== '') {
                        res.data = JSON.parse(apiCryptography.decrypt(res.data));
                    }
                }

                if (res.data.data) {
                    let LogItem = {
                        screen: 'ATM-Card-Activation',
                        activity: 'Activation Code validation',
                        url: `${process.env.REACT_APP_API_LINK}/card/validation`,
                        changes: '',
                        details: '',
                        callingMethodName: 'POST',
                        refno: cardNumber,
                        ipAdd: window.localStorage.getItem('LOCALIP') || '',
                    };
                    Log(LogItem);
                    var result = res.data.data;
                    
                    var currentURL = window.location.href;
                      //  if (result.toString().toLowerCase().includes("success")) {
                        if (result.isValid && result.message === "Valid" ) {
                            cardValidation(cardNumber, 4);
                            dispatch({
                            type: ACTIVATION_CODE_VALIDATION,
                            payload: result,
                            });
                            dispatch({
                                type: SET_REF_CODE,
                                payload: activationCode,
                                });
                        }
                        else {
                            dispatch({
                                type: SET_ERRORS,
                                payload: state.genericNotif
                            });
                        }
                } else {
                    var currentTimeStamp = moment().toDate(); //new Date();
                    try {
                        APIRequest.POST(`api/MW/Callapi`, {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                                Accept: 'application/json',
                            },
                            APIurl: `${process.env.REACT_APP_API_LINK}/card/ip-block`,
                            APIdata: apiCryptography.encrypt(`{Data: {ipAddress: '${window.localStorage.getItem('LOCALIP') || ''}', system: 'Green PIN - Corpsite', module: 'Activate ATM Card', action: 'Activation Code Validation', requestTime: '${currentTimeStamp.toISOString()}' }}`),
                            APImethod: 'POST',
                            APIsystem: 'ATM-Card-Activation',
                            APIreferenceno: cardNumber,
                            APIevent: 'IP Blocking Submit',
                        }).then((result) => {
                            var res = result;

                            if (res.data.error) {
                                nextStep(2);
                                dispatch({
                                    type: SET_ERRORS,
                                    payload: state.genericNotif,
                                });
                            } else {
                                if (res.data !== '') {
                                    res.data = JSON.parse(apiCryptography.decrypt(res.data));
                                }
                            }
                        });
                    }
                    catch (error) {
                        dispatch({
                            type: SET_ERRORS,
                            payload: state.genericNotif,
                        });
                    }
                    dispatch({
                        type: SET_ERRORS,
                        payload: res.data.errors ?
                            res.data.errors[0].message ||
                            res.data.errors[0].errorMessage : state.genericNotif
                    });
                }

            });
        }
        catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload: state.genericNotif,
            });
        }
    
    };

    const cardValidationMobileNumber = (cardNumber, mobileNumber, platform) => {
        setLoading();
        try {

            APIRequest.POST(`api/MW/Callapi`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json',
                },
                APIurl: `${process.env.REACT_APP_API_LINK}/card/ip-block`,
                APIData: apiCryptography.encrypt(`ipAddress=${window.localStorage.getItem('LOCALIP') || ''}`
                ),
                APImethod: 'GET',
                APIsystem: 'On-Boarding-Activate-Card',
                APIreferenceno: cardNumber,
                APIevent: 'IP Blocking',
            }).then((result) => {
                var response = result;
                if (response.data.error || response.status !== 200) {
                    nextStep(2);
                    dispatch({
                        type: SET_ERRORS,
                        payload: state.genericNotif,
                    });
                }
                else {
                    if (response.data !== '') {
                        response.data = JSON.parse(apiCryptography.decrypt(response.data));
                    }
                }
                //IP Blocking Checking
                if (response.data.data) {
                    var result = response.data.data;
                    if (result.isValid == true) {
                        try {
                            APIRequest.POST(`api/MW/Callapi`, {
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                    Accept: 'application/json',
                                },
                                APIurl: `${process.env.REACT_APP_API_LINK}/card/validation`,
                                APIdata: apiCryptography.encrypt(`{Data: {cardNumber: '${cardNumber}',mobileNumber: '${mobileNumber}', platform: '${platform}'}}`),
                                APImethod: 'POST',
                                APIsystem: 'ATM-Card-Activation',
                                APIreferenceno: cardNumber,
                                APIevent: 'Submit card number and mobile number',
                            }).then((result) => {
                                var res = result;

                                if (res.data.error) {
                                    nextStep(2);
                                    dispatch({
                                        type: SET_ERRORS,
                                        payload: state.genericNotif,
                                    });
                                } else {
                                    if (res.data !== '') {
                                        res.data = JSON.parse(apiCryptography.decrypt(res.data));
                                    }
                                }

                                if (res.data.data) {
                                    let LogItem = {
                                        screen: 'ATM-Card-Activation',
                                        activity: 'Submit card number and birthday',
                                        url: `${process.env.REACT_APP_API_LINK}/card/validation`,
                                        changes: '',
                                        details: '',
                                        callingMethodName: 'POST',
                                        refno: cardNumber,
                                        ipAdd: window.localStorage.getItem('LOCALIP') || '',
                                    };

                                    Log(LogItem);
                                    var result = res.data.data;

                                    dispatch({
                                        type: ATM_CARD_VALIDATION,
                                        payload: result,
                                    });

                                    nextStep(5);

                                } else {
                                    dispatch({
                                        type: SET_ERRORS,
                                        payload:
                                            //res.data.errors[0].message || 
                                            state.genericNotif
                                    });

                                    var currentTimeStamp = moment().toDate(); //new Date();

                                    try {
                                        APIRequest.POST(`api/MW/Callapi`, {
                                            headers: {
                                                'Content-Type': 'application/x-www-form-urlencoded',
                                                Accept: 'application/json',
                                            },
                                            APIurl: `${process.env.REACT_APP_API_LINK}/card/ip-block`,
                                            APIdata: apiCryptography.encrypt(`{Data: {ipAddress: '${window.localStorage.getItem('LOCALIP') || ''}', system: 'Green PIN - Corpsite', module: 'Activate ATM Card', action: 'Card Validation', requestTime: '${currentTimeStamp.toISOString()}' }}`),
                                            APImethod: 'POST',
                                            APIsystem: 'ATM-Card-Activation',
                                            APIreferenceno: cardNumber,
                                            APIevent: 'IP Blocking Submit',
                                        }).then((result) => {
                                            var res = result;

                                            if (res.data.error) {
                                                nextStep(2);
                                                dispatch({
                                                    type: SET_ERRORS,
                                                    payload: state.genericNotif,
                                                });
                                            } else {
                                                if (res.data !== '') {
                                                    res.data = JSON.parse(apiCryptography.decrypt(res.data));
                                                }
                                            }

                                        });
                                    }
                                    catch (error) {
                                        dispatch({
                                            type: SET_ERRORS,
                                            payload: state.genericNotif,
                                        });
                                    }


                                }
                            });
                        }
                        catch (error) {
                            nextStep(2);
                            dispatch({
                                type: SET_ERRORS,
                                payload: state.genericNotif,
                            });
                        }

                    }
                    else {
                        dispatch({
                            type: SET_ERRORS,
                            payload: result.message
                        });
                    }
                }
                else {
                    dispatch({
                        type: SET_ERRORS,
                        payload: Boolean(typeof response.data.errors !== "undefined") ?
                            response.data.errors[0].message :
                            state.genericNotif
                    });
                }
            });
        }
        catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload: state.genericNotif,
            });
        }
    };

    const atmCardActivationSubmit = (cardNumber, pinBlock, key, iv, referenceCode) => {
        setLoading();
        try {
            APIRequest.POST(`api/MW/Callapi`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json',
                },
                APIurl: `${process.env.REACT_APP_API_LINK}/card/pin`,
                //APIdata: apiCryptography.encrypt(`{Data: {cardNumber: '${cardNumber}', encryptedPinBlock: '${pinBlock}', encryptedAESKey: '${key}', encryptedAESIV: '${iv}'}}`),
                APIdata: apiCryptography.encrypt(`{Data: {cardNumber: '${cardNumber}', encryptedPinBlock: '${pinBlock}', encryptedAESKey: '${key}', encryptedAESIV: '${iv}', referenceCode: '${referenceCode}'}}`),
                APImethod: 'POST',
                APIsystem: 'ATM-Card-Activation',
                APIreferenceno: cardNumber,
                APIevent: 'Submit Atm Card Activation',
            }).then((result) => {
                var res = result;

                if (res.data.error) {
                    nextStep(2);
                    dispatch({
                        type: SET_ERRORS,
                        payload: state.genericNotif,
                    });
                } else {
                    if (res.data !== '') {
                        res.data = JSON.parse(apiCryptography.decrypt(res.data));
                    }
                }

                if (res.data.data) {
                    let LogItem = {
                        screen: 'Atm-Card-Activation',
                        activity: 'Submit Atm Card Activation',
                        url: `${process.env.REACT_APP_API_LINK}/card/pin`,
                        changes: '',
                        details: '',
                        callingMethodName: 'POST',
                        refno: cardNumber,
                        ipAdd: window.localStorage.getItem('LOCALIP') || '',
                    };

                    Log(LogItem);
                    var result = res.data.data;

                    dispatch({
                        type: ATM_CARD_ACTIVATION_SUBMIT,
                        payload: result,
                    });

                    nextStep(6);
                } else {
                    dispatch({
                        type: SET_ERRORS,
                        payload: state.genericNotif
                    });
                }
            });
        }
        catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload: state.genericNotif,
            });
        }
    };

        const validateOldPinSubmit = async ( mobileNumber, cardNumber, oldPin, pin, confirmPin) => {
        setLoading();
        //    localStorage.setItem('LOCALIP', localIpUrl('public'));

        APIRequest.POST(`api/MW/Callapi`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json',
            },
            APIurl: `${process.env.REACT_APP_API_LINK}/card/ip-block`,
            APIData: apiCryptography.encrypt(`ipAddress=${window.localStorage.getItem('LOCALIP') || ''}`
            ),
            APImethod: 'GET',
            APIsystem: 'On-Boarding-Change-Pin',
            APIreferenceno: cardNumber,
            APIevent: 'IP Blocking',
        }).then((result) => {
            var response = result;
            if (response.data.error || response.status !== 200) {
                nextStep(2);
                dispatch({
                    type: SET_ERRORS,
                    payload: 'Flexi Card Change Pin is temporarily unavailable. Please try again later.',
                });
            }
            else {
                if (response.data !== '') {
                    response.data = JSON.parse(apiCryptography.decrypt(response.data));
                }
            }
            //IP Blocking Checking
            if (response.data.data) {
                var result = response.data.data;
                if (result.isValid == true) {
                    try {

                        var key = 'UqUbiv2H7SX3IE5mdAN2T8DGCww0kpp+UDG7eILHcVY=';
                        var iv = 'MbKJXYHh6ev28asf30Q5lw==';
                        var keyBytes = _base64ToArrayBuffer('UqUbiv2H7SX3IE5mdAN2T8DGCww0kpp+UDG7eILHcVY=');
                        var iVBytes = _base64ToArrayBuffer('MbKJXYHh6ev28asf30Q5lw==');
                        var epin = '';
                        var options = {
                            encryptionScheme: {
                                scheme: 'pkcs1', //scheme
                            }
                        };

                        const NodeRSA = require('node-rsa');
                        const keyRsa = new NodeRSA('-----BEGIN RSA PUBLIC KEY-----' + state.atmCardValidation.rsaPublicKey + '-----END RSA PUBLIC KEY-----');
                        keyRsa.setOptions(options);

                        const encryptedAESKey = keyRsa.encrypt(key, 'base64');
                        const encryptedAESIV = keyRsa.encrypt(iv, 'base64');

                        var a = hexToBytes(generatePreparedPin(pin));
                        var b = hexToBytes(generatePreparedPan(cardNumber));
                        var c = xor(a, b);

                        var preparedOldPin = hexToBytes(generatePreparedPin(oldPin));
                        var xorOldPin = xor(preparedOldPin, b);

                        var d = aesjs.utils.hex.fromBytes(c);
                        var textBytes = aesjs.utils.utf8.toBytes(d);

                        var hexFromBytesOldPin = aesjs.utils.hex.fromBytes(xorOldPin);
                        var textBytesOldPin = aesjs.utils.utf8.toBytes(hexFromBytesOldPin);

                        var aesCbc = new aesjs.ModeOfOperation.cbc(keyBytes, iVBytes);
                        var encryptedPinBlock = aesCbc.encrypt(textBytes);

                        var aesCbcOld = new aesjs.ModeOfOperation.cbc(keyBytes, iVBytes);
                        var enrcyptedOldPinBlock = aesCbcOld.encrypt(textBytesOldPin);

                        var rawPinBlock = aesjs.utils.hex.fromBytes(encryptedPinBlock);
                        var rawOldPinBlock = aesjs.utils.hex.fromBytes(enrcyptedOldPinBlock);

                        localStorage.setItem('FAILEDOTPTRY', 0);

                        try {
                            APIRequest.POST(`api/MW/Callapi`, {
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                    Accept: 'application/json',
                                },
                                APIurl: `${process.env.REACT_APP_API_LINK}/card/pin/validation`,
                                APIdata: apiCryptography.encrypt(`cardNumber=${cardNumber}&encryptedPinBlock=${rawOldPinBlock}&encryptedAESKey=${encryptedAESKey}&encryptedAESIV=${encryptedAESIV}`),
                                APImethod: 'GET',
                               // APIurl: `${process.env.REACT_APP_API_LINK}/card/pin`,
                               // APIdata: apiCryptography.encrypt(`{Data: {cardNumber: '${cardNumber}', encryptedPinBlock: '${rawOldPinBlock}', encryptedAESKey: '${encryptedAESKey}', encryptedAESIV: '${encryptedAESIV}'}}`),
                               // APImethod: 'POST',                               
                                APIsystem: 'Change-Pin',
                                APIreferenceno: cardNumber,
                                APIevent: 'Submit Atm Card Change Pin',
                            }).then((result) => {
                                var res = result;
                                if (res.data.error) {
                                    nextStep(2);
                                    dispatch({
                                        type: SET_ERRORS,
                                        payload: state.genericNotif,
                                    });
                                } else {
                                    if (res.data !== '') {
                                        res.data = JSON.parse(apiCryptography.decrypt(res.data));
                                    }
                                }

                                if (res.data.data) {
                                    let LogItem = {
                                        screen: 'Change Pin',
                                        activity: 'Submit Atm Card Change Pin',
                                        url: `${process.env.REACT_APP_API_LINK}/card/pin`,
                                        changes: '',
                                        details: '',
                                        callingMethodName: 'PUT',
                                        refno: cardNumber,
                                        ipAdd: window.localStorage.getItem('LOCALIP') || '',
                                    };

                                    Log(LogItem);
                                    var result = res.data.data;

                                    dispatch({
                                        type: OLD_PIN_VALIDATION,
                                        payload: result,
                                    });

                                    debugger;
                                    if (result.isValid === true) {
                                        otpRequest(mobileNumber);
                                    }
                                } else {
                                    dispatch({
                                        type: SET_ERRORS,
                                        payload:
                                            'You have entered an invalid information, please call our 24/7 Customer Experience Hotline at (632) 8845-8888 for assistance'
                                    });
                                }
                            });

                        } catch (error) {
                            nextStep(2);
                            dispatch({
                                type: SET_ERRORS,
                                payload:
                                    'Flexi Card Change Pin is temporarily unavailable. Please try again later.',
                            });
                        }

                    
                    } catch (error) {
                        nextStep(2);
                        dispatch({
                            type: SET_ERRORS,
                            payload:
                                'Flexi Card Change Pin is temporarily unavailable. Please try again later.',
                        });
                    }
                }
                    else {
                        //nextStep(2);
                        dispatch({
                            type: SET_ERRORS,
                            payload: result.message,
                        });
                    }
                }

            })

    };


    const changePinSubmit = (cardNumber, oldPinBlock, pinBlock, key, iv) => {
        setLoading();
        try {
            APIRequest.POST(`api/MW/Callapi`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json',
                },
                APIurl: `${process.env.REACT_APP_API_LINK}/card/pin`,
                APIdata: apiCryptography.encrypt(`{Data: {cardNumber: '${cardNumber}', encryptedPinBlockOld: '${oldPinBlock}', encryptedPinBlockNew: '${pinBlock}', encryptedAESKey: '${key}', encryptedAESIV: '${iv}'}}`),
                APImethod: 'PUT',
                APIsystem: 'Change-Pin',
                APIreferenceno: cardNumber,
                APIevent: 'Submit Atm Card Change Pin',
            }).then((result) => {
                var res = result;
                debugger;
                if (res.data.error) {
                    nextStep(2);
                    dispatch({
                        type: SET_ERRORS,
                        payload: state.genericNotif,
                    });
                } else {
                    if (res.data !== '') {
                        res.data = JSON.parse(apiCryptography.decrypt(res.data));
                    }
                }

                if (res.data.data) {
                    let LogItem = {
                        screen: 'Change Pin',
                        activity: 'Submit Atm Card Change Pin',
                        url: `${process.env.REACT_APP_API_LINK}/card/pin`,
                        changes: '',
                        details: '',
                        callingMethodName: 'PUT',
                        refno: cardNumber,
                        ipAdd: window.localStorage.getItem('LOCALIP') || '',
                    };

                    Log(LogItem);
                    var result = res.data.data;

                    dispatch({
                        type: CHANGE_ATM_PIN,
                        payload: result,
                    });

                    nextStep(6);
                } else {
                    dispatch({
                        type: SET_ERRORS,
                        payload:
                            'You have entered an invalid information, please call our 24/7 Customer Experience Hotline at (632) 8845-8888 for assistance'
                    });
                }
            });
        }
        catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload: state.genericNotif,
            });
        }
    };

    const nominatePin = (pin, activationCode) => {
        setLoading();
        try {
            dispatch({
                type: SET_NOMINATED_PIN,
                payload: pin,
            });
        } catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload:
                    'Flexi Card Activation is temporarily unavailable. Please try again later.',
            });
        }
    }

    const oldPin = (oldPin) => {
        setLoading();
        try {
            dispatch({
                type: SET_OLD_PIN,
                payload: oldPin,
            });
        } catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload:
                    'Flexi Card Change Pin is temporarily unavailable. Please try again later.',
            });
        }
    }

    const submitNominatedPin = async (mobileNo, otp, cardNumber, pin, confirmPin) => {
        setLoading();
        var otpTry = parseInt(window.localStorage.getItem('LOCALIP') || 0);

        // localStorage.setItem('LOCALIP', localIpUrl('public'));

        APIRequest.POST(`api/MW/Callapi`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json',
            },
            APIurl: `${process.env.REACT_APP_API_LINK}/card/ip-block`,
            APIData: apiCryptography.encrypt(
                `ipAddress=${window.localStorage.getItem('LOCALIP') || ''}`
            ),
            APImethod: 'GET',
            APIsystem: 'On-Boarding-Activate-Card',
            APIreferenceno: cardNumber,
            APIevent: 'IP Blocking',
        }).then((result) => {
            var response = result;
            if (response.data.error || response.status !== 200) {
                nextStep(2);
                dispatch({
                    type: SET_ERRORS,
                    payload: 'Flexi Card Change Pin is temporarily unavailable. Please try again later.',
                });
            }
            else {
                if (response.data !== '') {
                    response.data = JSON.parse(apiCryptography.decrypt(response.data));
                }
            }
            //IP Blocking Checking
            if (response.data.data) {
                var result = response.data.data;
                if (result.isValid == true) {
                    // if (response.status === 200) {
                    try {
                        APIRequest.POST(`api/MW/Callapi`, {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                                Accept: 'application/json',
                            },
                            APIurl: `${process.env.REACT_APP_API_LINK}/otp/validate`,

                            APIdata: apiCryptography.encrypt(`{Data: {
                        mobilenumber: '${mobileNo}',
                        otp: '${otp}',          
                      }}`),

                            APImethod: 'POST',
                            APIsystem: 'Atm Card Activation',
                            APIreferenceno: mobileNo,
                            APIevent: 'validate OTP',
                        }).then(
                            (result) => {
                                var res = result;
                                if (res.data.error) {
                                    nextStep(2);
                                    dispatch({
                                        type: SET_ERRORS,
                                        payload:
                                            'Flexi Card Activation is temporarily unavailable. Please try again later.',
                                    });
                                } else {
                                    if (res.data !== '') {
                                        res.data = JSON.parse(apiCryptography.decrypt(res.data));
                                    }
                                }
                                console.log(res);
                                if (res.data.data) {
                                    if (res.data.data.isValid) {

                                        let LogItem = {
                                            screen: 'Atm Card Activation',
                                            activity: 'validate OTP',
                                            url: `${process.env.REACT_APP_API_LINK}/otp/validate`,
                                            changes: '',
                                            details: apiCryptography.encrypt(`{Data: {mobilenumber: '${mobileNo}',otp: '${otp}',}}`),
                                            callingMethodName: 'POST',
                                            refno: mobileNo,
                                            ipAdd: window.localStorage.getItem('LOCALIP') || '',
                                        };

                                        Log(LogItem);

                                        var key = 'UqUbiv2H7SX3IE5mdAN2T8DGCww0kpp+UDG7eILHcVY=';
                                        var iv = 'MbKJXYHh6ev28asf30Q5lw==';
                                        var keyBytes = _base64ToArrayBuffer('UqUbiv2H7SX3IE5mdAN2T8DGCww0kpp+UDG7eILHcVY=');
                                        var iVBytes = _base64ToArrayBuffer('MbKJXYHh6ev28asf30Q5lw==');

                                        var options = {
                                            encryptionScheme: {
                                                scheme: 'pkcs1', //scheme
                                            }
                                        };

                                        const NodeRSA = require('node-rsa');
                                        const keyRsa = new NodeRSA('-----BEGIN RSA PUBLIC KEY-----' + state.atmCardValidation.rsaPublicKey + '-----END RSA PUBLIC KEY-----');
                                        keyRsa.setOptions(options);
                                        //const keyRsa = new NodeRSA('-----BEGIN RSA PUBLIC KEY-----MIGJAoGBAJLA86PjJweabGwI38sqHFOWLj/NcW8Wc9QDop+6WwgwNoggalD/V3gQjt1mAS08mtjKuQoaFis9t+6bUoOdMbe6P1j1Thp+Sgc6pkPgN9xI9TwNZOqy9HV9Ssn+XX/qFi5Az/Iqn256/X/qgULw6RISY2iqS7VOR1hfma5fgaOfAgMBAAE=-----END RSA PUBLIC KEY-----');

                                        const encryptedAESKey = keyRsa.encrypt(key, 'base64');
                                        const encryptedAESIV = keyRsa.encrypt(iv, 'base64');

                                        //console.log('Encrypted AES Key: ' + encryptedAESKey);
                                        //console.log('Encrypted AES IV: ' + encryptedAESIV);

                                        generatePreparedPan(cardNumber);
                                        generatePreparedPin(pin);

                                        var a = hexToBytes(generatePreparedPin(pin));
                                        var b = hexToBytes(generatePreparedPan(cardNumber));

                                        //console.log(a);
                                        //console.log(b);
                                        //console.log(xor(a, b));

                                        var c = xor(a, b);
                                        //console.log(aesjs.utils.hex.fromBytes(c));

                                        var d = aesjs.utils.hex.fromBytes(c);
                                        var textBytes = aesjs.utils.utf8.toBytes(d);

                                        var aesCbc = new aesjs.ModeOfOperation.cbc(keyBytes, iVBytes);
                                        var encryptedPinBlock = aesCbc.encrypt(textBytes);

                                        //console.log(encryptedPinBlock);
                                        //console.log(aesjs.utils.hex.fromBytes(encryptedPinBlock));

                                        var rawPinBlock = aesjs.utils.hex.fromBytes(encryptedPinBlock);
                                        //atmCardActivationSubmit(cardNumber, rawPinBlock, encryptedAESKey, encryptedAESIV);
                                        atmCardActivationSubmit(cardNumber, rawPinBlock, encryptedAESKey, encryptedAESIV,state.referenceCode);
                                        localStorage.setItem('FAILEDOTPTRY', 0);

                                    } else {
                                        dispatch({
                                            type: SET_ERRORS,
                                            payload: 'Invalid OTP',
                                        });

                                        var currentTimeStamp = moment().toDate();

                                        try {
                                            APIRequest.POST(`api/MW/Callapi`, {
                                                headers: {
                                                    'Content-Type': 'application/x-www-form-urlencoded',
                                                    Accept: 'application/json',
                                                },
                                                APIurl: `${process.env.REACT_APP_API_LINK}/card/ip-block`,
                                                APIdata: apiCryptography.encrypt(`{Data: {ipAddress: '${window.localStorage.getItem('LOCALIP') || ''}', system: 'Green PIN - Corpsite', module: 'Activate ATM Card', action: 'Card Validation', requestTime: '${currentTimeStamp.toISOString()}' }}`),
                                                APImethod: 'POST',
                                                APIsystem: 'ATM-Card-Activation',
                                                APIreferenceno: cardNumber,
                                                APIevent: 'IP Blocking Submit',
                                            }).then((result) => {
                                                var res = result;

                                                if (res.data.error) {
                                                    nextStep(2);
                                                    dispatch({
                                                        type: SET_ERRORS,
                                                        payload: state.genericNotif,
                                                    });
                                                } else {
                                                    if (res.data !== '') {
                                                        res.data = JSON.parse(apiCryptography.decrypt(res.data));
                                                    }
                                                }

                                                /* if (res.data.data) {
                                                    //Nothing happens
                                                } else {
                                                    dispatch({
                                                        type: SET_ERRORS,
                                                        payload:
                                                            res.data.errors[0].message ||
                                                            res.data.errors[0].errorMessage
                                                    });
                                                } */
                                            });
                                        }
                                        catch (error) {
                                            dispatch({
                                                type: SET_ERRORS,
                                                payload: state.genericNotif,
                                            });
                                        }

                                    }
                                } else {
                                    nextStep(2);
                                    dispatch({
                                        type: SET_ERRORS,
                                        payload:
                                            'Flexi Card Activation is temporarily unavailable. Please try again later.',
                                    });
                                }
                            },
                            (error) => {
                                nextStep(2);
                                dispatch({
                                    type: SET_ERRORS,
                                    payload:
                                        'Flexi Card Activation is temporarily unavailable. Please try again later.',
                                });
                            }
                        );
                    } catch (error) {
                        nextStep(2);
                        dispatch({
                            type: SET_ERRORS,
                            payload:
                                'Flexi Card Change Pin is temporarily unavailable. Please try again later.',
                        });
                    }

                } else {
                    //nextStep(2);
                    dispatch({
                        type: SET_ERRORS,
                        payload: result.message,
                    });
                }
            }

        })


    };

    const submitNewNominatedPin = async (mobileNo, otp, cardNumber, oldPin, pin, confirmPin) => {
        setLoading();
        var otpTry = parseInt(localStorage.getItem('FAILEDOTPTRY') || 0);

        //    localStorage.setItem('LOCALIP', localIpUrl('public'));

        APIRequest.POST(`api/MW/Callapi`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json',
            },
            APIurl: `${process.env.REACT_APP_API_LINK}/card/ip-block`,
            APIData: apiCryptography.encrypt(
                `ipAddress=${window.localStorage.getItem('LOCALIP') || ''}`
            ),
            APImethod: 'GET',
            APIsystem: 'On-Boarding-Change-Pin',
            APIreferenceno: cardNumber,
            APIevent: 'IP Blocking',
        }).then((result) => {
            var response = result;
            if (response.data.error || response.status !== 200) {
                nextStep(2);
                dispatch({
                    type: SET_ERRORS,
                    payload: 'Flexi Card Change Pin is temporarily unavailable. Please try again later.',
                });
            }
            else {
                if (response.data !== '') {
                    response.data = JSON.parse(apiCryptography.decrypt(response.data));
                }
            }
            //IP Blocking Checking
            if (response.data.data) {
                var result = response.data.data;
                if (result.isValid == true) {
                    // if (response.status === 200) {
                    try {
                        APIRequest.POST(`api/MW/Callapi`, {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                                Accept: 'application/json',
                            },
                            APIurl: `${process.env.REACT_APP_API_LINK}/otp/validate`,
                            APIdata: apiCryptography.encrypt(`{Data: {
            mobilenumber: '${mobileNo}',
            otp: '${otp}',          
          }}`),

                            APImethod: 'POST',
                            APIsystem: 'On-Boarding-Document-Upload',
                            APIreferenceno: mobileNo,
                            APIevent: 'validate OTP',
                        }).then(
                            (result) => {
                                var res = result;
                                if (res.data.error) {
                                    nextStep(2);
                                    dispatch({
                                        type: SET_ERRORS,
                                        payload:
                                            'Flexi Card Change Pin is temporarily unavailable. Please try again later.',
                                    });
                                } else {
                                    if (res.data !== '') {
                                        res.data = JSON.parse(apiCryptography.decrypt(res.data));
                                    }
                                }
                                console.log(res);
                                if (res.data.data) {
                                    if (res.data.data.isValid) {

                                        let LogItem = {
                                            screen: 'On-Boarding-Document-Upload',
                                            activity: 'Validate OTP',
                                            url: `${process.env.REACT_APP_API_LINK}/otp/validate`,
                                            changes: '',
                                            details: apiCryptography.encrypt(`{Data: {mobilenumber: '${mobileNo}',otp: '${otp}',}}`),
                                            callingMethodName: 'POST',
                                            refno: mobileNo,
                                            ipAdd: window.localStorage.getItem('LOCALIP') || '',
                                        };

                                        Log(LogItem);

                                        var key = 'UqUbiv2H7SX3IE5mdAN2T8DGCww0kpp+UDG7eILHcVY=';
                                        var iv = 'MbKJXYHh6ev28asf30Q5lw==';
                                        var keyBytes = _base64ToArrayBuffer('UqUbiv2H7SX3IE5mdAN2T8DGCww0kpp+UDG7eILHcVY=');
                                        var iVBytes = _base64ToArrayBuffer('MbKJXYHh6ev28asf30Q5lw==');

                                        var options = {
                                            encryptionScheme: {
                                                scheme: 'pkcs1', //scheme
                                            }
                                        };

                                        const NodeRSA = require('node-rsa');
                                        const keyRsa = new NodeRSA('-----BEGIN RSA PUBLIC KEY-----' + state.atmCardValidation.rsaPublicKey + '-----END RSA PUBLIC KEY-----');
                                        keyRsa.setOptions(options);

                                        const encryptedAESKey = keyRsa.encrypt(key, 'base64');
                                        const encryptedAESIV = keyRsa.encrypt(iv, 'base64');

                                        var a = hexToBytes(generatePreparedPin(pin));
                                        var b = hexToBytes(generatePreparedPan(cardNumber));
                                        var c = xor(a, b);

                                        var preparedOldPin = hexToBytes(generatePreparedPin(oldPin));
                                        var xorOldPin = xor(preparedOldPin, b);

                                        var d = aesjs.utils.hex.fromBytes(c);
                                        var textBytes = aesjs.utils.utf8.toBytes(d);

                                        var hexFromBytesOldPin = aesjs.utils.hex.fromBytes(xorOldPin);
                                        var textBytesOldPin = aesjs.utils.utf8.toBytes(hexFromBytesOldPin);

                                        var aesCbc = new aesjs.ModeOfOperation.cbc(keyBytes, iVBytes);
                                        var encryptedPinBlock = aesCbc.encrypt(textBytes);

                                        var aesCbcOld = new aesjs.ModeOfOperation.cbc(keyBytes, iVBytes);
                                        var enrcyptedOldPinBlock = aesCbcOld.encrypt(textBytesOldPin);

                                        var rawPinBlock = aesjs.utils.hex.fromBytes(encryptedPinBlock);
                                        var rawOldPinBlock = aesjs.utils.hex.fromBytes(enrcyptedOldPinBlock);

                                        changePinSubmit(cardNumber, rawOldPinBlock, rawPinBlock, encryptedAESKey, encryptedAESIV);
                                        localStorage.setItem('FAILEDOTPTRY', 0);

                                    } else {
                                        dispatch({
                                            type: SET_ERRORS,
                                            payload: 'Invalid OTP',
                                        });

                                        var currentTimeStamp = moment().toDate();

                                        try {
                                            APIRequest.POST(`api/MW/Callapi`, {
                                                headers: {
                                                    'Content-Type': 'application/x-www-form-urlencoded',
                                                    Accept: 'application/json',
                                                },
                                                APIurl: `${process.env.REACT_APP_API_LINK}/card/ip-block`,
                                                APIdata: apiCryptography.encrypt(`{Data: {ipAddress: '${window.localStorage.getItem('LOCALIP') || ''}', system: 'Green PIN - Corpsite', module: 'Activate ATM Card', action: 'Card Validation', requestTime: '${currentTimeStamp.toISOString()}' }}`),
                                                APImethod: 'POST',
                                                APIsystem: 'ATM-Card-Activation',
                                                APIreferenceno: cardNumber,
                                                APIevent: 'IP Blocking Submit',
                                            }).then((result) => {
                                                var res = result;

                                                if (res.data.error) {
                                                    nextStep(2);
                                                    dispatch({
                                                        type: SET_ERRORS,
                                                        payload: state.genericNotif,
                                                    });
                                                } else {
                                                    if (res.data !== '') {
                                                        res.data = JSON.parse(apiCryptography.decrypt(res.data));
                                                    }
                                                }

                                                /* if (res.data.data) {
                                                    //Nothing happens
                                                } else {
                                                    dispatch({
                                                        type: SET_ERRORS,
                                                        payload:
                                                            res.data.errors[0].message ||
                                                            res.data.errors[0].errorMessage
                                                    });
                                                } */
                                            });
                                        }
                                        catch (error) {
                                            dispatch({
                                                type: SET_ERRORS,
                                                payload: state.genericNotif,
                                            });
                                        }
                                    }
                                } else {
                                    nextStep(2);
                                    dispatch({
                                        type: SET_ERRORS,
                                        payload:
                                            'Flexi Card Change Pin is temporarily unavailable. Please try again later.',
                                    });
                                }
                            },
                            (error) => {
                                nextStep(2);
                                dispatch({
                                    type: SET_ERRORS,
                                    payload:
                                        'Flexi Card Change Pin is temporarily unavailable. Please try again later.',
                                });
                            }
                        );
                    } catch (error) {
                        nextStep(2);
                        dispatch({
                            type: SET_ERRORS,
                            payload:
                                'Flexi Card Change Pin is temporarily unavailable. Please try again later.',
                        });
                    }

                } else {
                    //nextStep(2);
                    dispatch({
                        type: SET_ERRORS,
                        payload: result.message,
                    });
                }
            }

        })

    };


    function generatePreparedPin(pin) {
        return 0 + pin.length.toString() + pin + ''.padEnd(16 - 8, 'F');
    }

    function generatePreparedPan(pan) {
        return '0000' + pan.slice(0, -1).substring(pan.length - 13);
    }

    function hexToBytes(hex) {
        for (var bytes = [], c = 0; c < hex.length; c += 2) {
            bytes.push(parseInt(hex.substr(c, 2), 16));
        }

        return bytes;
    }

    function bytesToHex(bytes) {
        for (var hex = [], i = 0; i < bytes.length; i++) {
            var current = bytes[i] < 0 ? bytes[i] + 256 : bytes[i];
            hex.push((current >>> 4).toString(16));
            hex.push((current >>> 0xF).toString(16));
        }

        return hex.join('');
    }

    function xor(a, b) {

        for (var bytes = [], i = 0; i < a.length; i++) {
            bytes.push(a[i] ^ b[i]);
        }

        return bytes;
    }

    function _base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes;
    }

    const getCardSessionValidation = (linkIdentifier) => {
        setLoading();
        try {
            APIRequest.POST(`api/MW/Callapi`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json',
                },
                APIurl: `${process.env.REACT_APP_API_LINK}/card/session/validation`,
                APIData: apiCryptography.encrypt(
                    `{Data: 'sessionid=${linkIdentifier}'}`
                ),
                APImethod: 'GET',
                APIsystem: 'On-Boarding-Activate-Card',
                APIreferenceno: linkIdentifier,
                APIevent: 'Get card details',
            }).then((result) => {
                var response = result;
                if (response.data.error) {
                    nextStep(2);
                    dispatch({
                        type: SET_ERRORS,
                        payload: 'Flexi Card activation is temporarily unavailable. Please try again later.',
                    });
                }
                else {
                    if (response.data !== '') {
                        response.data = JSON.parse(apiCryptography.decrypt(response.data));
                    }
                }

                if (response.data.data) {
                    let LogItem = {
                        screen: 'On-Boarding-Activate-Card',
                        activity: 'Get card details',
                        url: `${process.env.REACT_APP_API_LINK}/card/session/validation`,
                        changes: '',
                        details: 'Retrieve card details',
                        callingMethodName: 'GET',
                        refno: linkIdentifier.substring(10, 17),
                        ipAdd: window.localStorage.getItem('LOCALIP') || '',
                    };

                    Log(LogItem);
                    var result = response.data.data;
                    dispatch({
                        type: CARD_SESSION_VALIDATION,
                        payload: result,
                    });
                    //alert(state.cardSessionValidation.cardNumber);
                }
                else {
                    let LogItem = {
                        serviceName: `${process.env.REACT_APP_API_LINK}/card/session/validation`,
                        methodName: 'GET',
                        parameters: apiCryptography.encrypt(`{Data: {sessionid: '${linkIdentifier}'}}`),
                        error: `${response.data.errors[0].message}`
                    };

                    ErrorLog(LogItem);
                    dispatch({
                        type: SET_ERRORS,
                        payload:
                            response.data.errors[0].message ||
                            response.data.errors[0].errorMessage
                    });
                }
            });
        }
        catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload: 'Flexi Card Activation is temporarily unavailable. Please try again later.',
            });
        }
    };

    const setUserInfo = (refNo, birthDate) => {
        debugger;
        var gana = formatDate(birthDate);
        var loginTry = parseInt(localStorage.getItem('FAILEDLOGINTRY') || 0);

        setLoading();
        try {
            APIRequest.POST(`api/MW/CallApi`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json',
                },
                APIurl: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/applications/for-compliance/login`,
                APImethod: 'POST',
                APIdata: apiCryptography.encrypt(`{Data: {
          referencenumber: '${refNo}',
					birthdate: '${gana}',          
        }}`),
                APIsystem: 'On-Boarding-Document-Upload',
                APIreferenceno: refNo,
                APIevent: 'Login',
            }).then(
                (result) => {
                    try {
                        var res = result;
                        if (res.data.error) {
                            let LogItem = {
                                serviceName: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/applications/for-compliance/login`,
                                methodName: 'POST',
                                parameters: apiCryptography.encrypt(`{Data: {referencenumber: '${refNo}',birthdate: '${gana}',}}`),
                                error: 'Document upload is temporarily unavailable. Please try again later.',
                            };

                            ErrorLog(LogItem);

                            nextStep(2);
                            dispatch({
                                type: SET_ERRORS,
                                payload:
                                    'Document upload is temporarily unavailable. Please try again later.',
                            });
                        } else {
                            if (res.data !== '') {
                                res.data = JSON.parse(apiCryptography.decrypt(res.data));

                                let LogItem = {
                                    serviceName: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/applications/for-compliance/login`,
                                    methodName: 'POST',
                                    parameters: apiCryptography.encrypt(`{Data: {referencenumber: '${refNo}',birthdate: '${gana}',}}`),
                                    error: res.data,
                                };

                                ErrorLog(LogItem);
                            }
                        }
                        if (res !== undefined) {
                            let LogItem = {
                                screen: 'On-Boarding-Document-Upload',
                                activity: 'Login Reference Number: ' + refNo + ' Birthdate: ' + gana,
                                url: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/applications/for-compliance/login`,
                                changes: '',
                                details: apiCryptography.encrypt(`{Data: {referencenumber: '${refNo}',birthdate: '${gana}',}}`),
                                callingMethodName: 'POST',
                                refno: refNo.substring(10, 17),
                                ipAdd: window.localStorage.getItem('LOCALIP') || '',
                            };

                            Log(LogItem);

                            localStorage.setItem('FAILEDLOGINTRY', 0);
                            localStorage.setItem('FAILEDOTPTRY', 0);
                            if (res.data.data) {
                                dispatch({
                                    type: SET_USER_INFO,
                                    payload: res.data.data,
                                });
                                dispatch({
                                    type: GET_CUST_ID,
                                    payload: res.data.data.customerId,
                                });

                                dispatch({
                                    type: SET_TOKEN,
                                    payload: res.data.token,
                                });
                                //(res);
                                //requestForOTP(res.data.data.mobileNumber);
                                //getCompleteDetails(refNo);
                            } else if (res.data.errors) {
                                if (
                                    res.data.errors[0].errorCode === '-901050' ||
                                    res.data.errors[0].code === '-901050'
                                ) {
                                    loginTry = loginTry + 1;
                                    localStorage.setItem('FAILEDLOGINTRY', loginTry);

                                    dispatch({
                                        type: SET_USER_INFO,
                                        payload: null,
                                    });
                                    dispatch({
                                        type: GET_CUST_ID,
                                        payload: null,
                                    });

                                    dispatch({
                                        type: SET_TOKEN,
                                        payload: null,
                                    });
                                    dispatch({
                                        type: SET_ERRORS,
                                        // payload:
                                        //   res.data.errors[0].message ||
                                        //   res.data.errors[0].errorMessage,
                                        payload: 'Invalid Reference Number or Birth Date.',
                                    });


                                    if (loginTry >= 3) {
                                        var curTime = new Date();
                                        curTime.setMinutes(curTime.getMinutes() + 5);
                                        localStorage.setItem('LOCKTIME', curTime);
                                    }

                                    let LogItem = {
                                        serviceName: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/applications/for-compliance/login`,
                                        methodName: 'POST',
                                        parameters: apiCryptography.encrypt(`{Data: {referencenumber: '${refNo}',birthdate: '${gana}',}}`),
                                        error: 'Invalid Reference Number or Birth Date.',
                                        refno: refNo,
                                    };

                                    ErrorLog(LogItem);


                                } else {
                                    dispatch({
                                        type: SET_ERRORS,
                                        payload:
                                            res.data.errors[0].message ||
                                            res.data.errors[0].errorMessage,
                                        //payload: 'Invalid Reference Number/Birth Date.',
                                    });
                                }

                                //(res);
                            } else {
                                nextStep(2);
                                //(res);
                                dispatch({
                                    type: SET_ERRORS,
                                    payload:
                                        'Document upload is temporarily unavailable. Please try again later.',
                                });
                            }
                        } else {
                            //nextStep(3);
                            //(res);
                            dispatch({
                                type: SET_ERRORS,
                                payload:
                                    'Document upload is temporarily unavailable. Please try again later.',
                            });
                        }
                    } catch (error) {
                        nextStep(2);
                        dispatch({
                            type: SET_ERRORS,
                            payload:
                                'Document upload is temporarily unavailable. Please try again later.',
                        });
                        //(error);
                        //('error');
                    }
                },
                (error) => {
                    nextStep(2);
                    dispatch({
                        type: SET_ERRORS,
                        payload:
                            'Document upload is temporarily unavailable. Please try again later.',
                    });
                    //(error);
                }
            );
        } catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload:
                    'Document upload is temporarily unavailable. Please try again later.',
            });
            //(error);
            //('lol');
        }
    };

    const requestForOTP = (mobileNo) => {
        setLoading();
        try {
            APIRequest.POST(`api/MW/Callapi`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json',
                },
                APIurl: `${process.env.REACT_APP_API_LINK}/otp/request`,
                APIdata: apiCryptography.encrypt(`{Data: {mobilenumber: '${mobileNo}', module: 'ONBOARDING DOCUMENT UPLOAD',}}`),
                APImethod: 'POST',
                APIsystem: 'On-Boarding-Document-Upload',
                APIreferenceno: mobileNo,
                APIevent: 'OTP Request',
            }).then((result) => {
                var response = result;
                var result = response.data.data;
                dispatch({
                    type: SET_OTP_SUCCESS,
                    payload: result,
                });
            });

        } catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload:
                    'Document upload is temporarily unavailable. Please try again later.',
            });
            //(error);
            //('lol');
        }
    };

    const otpRequest = (mobileNumber) => {
        const currentURL = window.location.href;
        var moduleName = '';

        if (currentURL.toLowerCase().includes("activatecard")) {
            moduleName = 'ATM CARD ACTIVATION';
        }
        else if (currentURL.toLowerCase().includes("changepin")) {
            moduleName = 'ATM CARD CHANGE PIN';
        }
        else {
            moduleName = 'ONBOARDING SCHEDULER';
        }

        setLoading();
        APIRequest.POST(`api/MW/Callapi`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json',
            },
            APIurl: `${process.env.REACT_APP_API_LINK}/otp/request`,
            APIdata: apiCryptography.encrypt(`{Data: {mobilenumber: '${mobileNumber}', module: '${moduleName}',}}`),
            APImethod: 'POST',
            APIsystem: 'On-Boarding-Document-Upload',
            APIreferenceno: mobileNumber,
            APIevent: 'OTP Request',
        }).then((result) => {
            var response = result;
            var result = response.data.data;
            dispatch({
                type: SET_OTP_SUCCESS,
                payload: result,
            });
        });
    };

    const validateOTP = async (mobileNo, otp) => {
        setLoading();
        var otpTry = parseInt(localStorage.getItem('FAILEDOTPTRY') || 0);
        try {
            APIRequest.POST(`api/MW/Callapi`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json',
                },
                APIurl: `${process.env.REACT_APP_API_LINK}/otp/validate`,

                APIdata: apiCryptography.encrypt(`{Data: {
            mobilenumber: '${mobileNo}',
            otp: '${otp}',          
          }}`),

                APImethod: 'POST',
                APIsystem: 'On-Boarding-Document-Upload',
                APIreferenceno: mobileNo,
                APIevent: 'validate OTP',
            }).then(
                (result) => {
                    var res = result;
                    if (res.data.error) {
                        nextStep(2);
                        dispatch({
                            type: SET_ERRORS,
                            payload:
                                'Document upload is temporarily unavailable. Please try again later.',
                        });
                    } else {
                        if (res.data !== '') {
                            res.data = JSON.parse(apiCryptography.decrypt(res.data));
                        }
                    }
                    console.log(res);
                    if (res.data.data) {
                        if (res.data.data.isValid) {

                            let LogItem = {
                                screen: 'On-Boarding-Document-Upload',
                                activity: 'validate OTP',
                                url: `${process.env.REACT_APP_API_LINK}/otp/validate`,
                                changes: '',
                                details: apiCryptography.encrypt(`{Data: {mobilenumber: '${mobileNo}',otp: '${otp}',}}`),
                                callingMethodName: 'POST',
                                refno: mobileNo,
                                ipAdd: window.localStorage.getItem('LOCALIP') || '',
                            };

                            Log(LogItem);
                            nextStep(state.step);

                            localStorage.setItem('FAILEDOTPTRY', 0);
                            //(res);
                            //('1');
                        } else {
                            dispatch({
                                type: SET_ERRORS,
                                payload: 'Invalid OTP',
                            });

                            otpTry = otpTry + 1;
                            localStorage.setItem('FAILEDOTPTRY', otpTry);

                            if (otpTry >= 3) {
                                var curTime = new Date();
                                curTime.setMinutes(curTime.getMinutes() + 5);
                                localStorage.setItem('LOCKOTPTIME', curTime);
                            }
                        }
                    } else {
                        //(res);
                        nextStep(2);
                        dispatch({
                            type: SET_ERRORS,
                            payload: state.genericNotif,
                        });
                    }
                },
                (error) => {
                    nextStep(2);
                    dispatch({
                        type: SET_ERRORS,
                        payload: state.genericNotif,
                    });
                    //(error);
                }
            );
        } catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload: state.genericNotif,
            });
            //(error);
            //('lol');
        }
    };


    //////////Document Upload///////////////
    const getComplianceDocuments = (refNo) => {
        try {
            APIRequest.POST(`api/MW/Callapi`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json',
                },
                APIurl: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/applications/for-compliance/${refNo}`,
                APImethod: 'GET',
                APIsystem: 'On-Boarding-Document-Upload',
                APIreferenceno: refNo,
                APIevent: 'Get User For Compliance Requirements',
            }).then(
                (result) => {
                    var res = result;
                    if (res.data.error) {
                        nextStep(2);
                        dispatch({
                            type: SET_ERRORS,
                            payload:
                                'Document upload is temporarily unavailable. Please try again later.',
                        });
                    } else {
                        if (res.data !== '') {
                            res.data = JSON.parse(apiCryptography.decrypt(res.data));
                        }
                    }
                    if (res.data.data) {

                        let LogItem = {
                            screen: 'On-Boarding-Document-Upload',
                            activity: 'Get User For Compliance Requirements',
                            url: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/applications/for-compliance/${refNo}`,
                            changes: '',
                            details: '',
                            callingMethodName: 'GET',
                            refno: refNo.substring(10, 17),
                            ipAdd: window.localStorage.getItem('LOCALIP') || '',
                        };

                        Log(LogItem);

                        //assign result to var to change the value
                        var result = res.data.data;
                        //end

                        //set ordernumber of all doc to 1
                        res.data.data.documents.forEach(function (doc) {
                            doc.orderNumber = 1;
                        });
                        //end

                        //extract the prc id from the documents
                        var prc = [...res.data.data.documents].filter(
                            (x) => x.description === 'PRC ID'
                        );
                        //end

                        //recreate docs for prc front and back
                        if (prc.length > 0) {
                            var prcBack = {
                                documentId: prc[0].documentId,
                                front: prc[0].front,
                                level: prc[0].level,
                                code: prc[0].code,
                                description: prc[0].description + ' (back)',
                                orderNumber: 1,
                            };

                            var prcFront = {
                                documentId: prc[0].documentId,
                                front: prc[0].front,
                                level: prc[0].level,
                                code: prc[0].code,
                                description: prc[0].description + ' (front)',
                                orderNumber: 2,
                            };

                            // attached the new prc id's to the documents
                            var documents = [
                                //remove the prc from the the documents
                                ...[...res.data.data.documents].filter(
                                    (x) => x.description !== 'PRC ID'
                                ),
                                prcBack,
                                prcFront,
                            ];
                            //end

                            result.documents = documents;
                        }
                        //end
                        //(result);
                        dispatch({
                            type: GET_COMPLIANCE_DOCUMENTS,
                            payload: result,
                        });
                    } else if (res.data.errors) {
                        dispatch({
                            type: SET_ERRORS,
                            payload: res.data.errors[0].message,
                        });
                        //(res);
                    } else {
                        nextStep(2);
                        dispatch({
                            type: SET_ERRORS,
                            payload:
                                'Document upload is temporarily unavailable. Please try again later.',
                        });
                        //(res);
                    }
                },
                (error) => {
                    nextStep(2);
                    dispatch({
                        type: SET_ERRORS,
                        payload:
                            'Document upload is temporarily unavailable. Please try again later.',
                    });
                    //(error);
                }
            );
        } catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload:
                    'Document upload is temporarily unavailable. Please try again later.',
            });
            ////(res);
            //(error);
        }
    };

    const setAddRequiredDocu = () => state.noOfRequiredDocs + 1;

    const uploadDocument = async (doc) => {
        dispatch({
            type: UPLOAD_DOCUMENT,
            payload: doc,
        });
    };

    const deleteDocuments = () => {
        setLoading();
        try {
            let ctr = 0;

            return new Promise(
                async (resolve, reject) => {
                    try {
                        console.log('deleteDocuments');
                        var res = await APIRequest.POST(`api/MW/Callapi`, {
                            APIurl: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/documents`,
                            APIData: apiCryptography.encrypt(
                                `{Data: 'referencenumber=${state.userInfo.referenceNumber}&requestor=CLIENT'}`
                            ),
                            APImethod: 'GET',
                            APIsystem: 'On-Boarding-Document-Upload',
                            APIreferenceno: state.userInfo.referenceNumber,
                            APIevent: 'GET Initial Document then Delete',
                        });
                        console.log(res);
                        ////(res);
                        if (res !== undefined) {
                            if (res.data.error) {
                                nextStep(2);
                                dispatch({
                                    type: SET_ERRORS,
                                    payload:
                                        'Document upload is temporarily unavailable. Please try again later.',
                                });
                            } else {
                                if (res.data !== '') {
                                    res.data = JSON.parse(apiCryptography.decrypt(res.data));
                                }
                            }
                            if (res.data.data) {

                                let LogItem = {
                                    screen: 'On-Boarding-Document-Upload',
                                    activity: 'GET Initial Document then Delete',
                                    url: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/documents`,
                                    changes: '',
                                    details: apiCryptography.encrypt(`{Data: 'referencenumber=${state.userInfo.referenceNumber}&requestor=CLIENT'}`),
                                    callingMethodName: 'GET',
                                    refno: state.userInfo.referenceNumber.substring(10, 17),
                                    ipAdd: window.localStorage.getItem('LOCALIP') || '',
                                };

                                Log(LogItem);

                                ////(res);
                                if (res.data.data.image) {
                                    //(res);
                                    var images = res.data.data.image;
                                    state.uploadedDocuments.forEach((doc) => {
                                        var savedDocs = images.filter(function (savedDoc) {
                                            return (
                                                savedDoc.documentType === doc.documentType
                                                //&&
                                                //savedDoc.orderNumber === doc.orderNumber
                                            );
                                        });
                                        ////(savedDocs);
                                        if (savedDocs.length > 0) {
                                            savedDocs.forEach(async (savedDoc) => {
                                                // eslint-disable-next-line
                                                var res = await APIRequest.POST(`api/MW/Callapi`, {
                                                    APIurl: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/documents`,
                                                    APIData: apiCryptography.encrypt(
                                                        `{Data: 'referenceNumber=${state.userInfo.referenceNumber}&requestor=CLIENT&documentID=${savedDoc.documentID}'}`
                                                    ),
                                                    APImethod: 'DELETE',
                                                    APIsystem: 'On-Boarding-Document-Upload',
                                                    APIreferenceno: state.userInfo.referenceNumber,
                                                    APIevent: 'Delete Initial Uploaded Documents',
                                                });
                                                try {
                                                    if (res.data.error) {
                                                        nextStep(2);
                                                        dispatch({
                                                            type: SET_ERRORS,
                                                            payload:
                                                                'Document upload is temporarily unavailable. Please try again later.',
                                                        });
                                                    } else {
                                                        if (res.data !== '') {
                                                            res.data = JSON.parse(
                                                                apiCryptography.decrypt(res.data)
                                                            );
                                                        }
                                                    }
                                                    if (res.data.data) {

                                                        let LogItem = {
                                                            screen: 'On-Boarding-Document-Upload',
                                                            activity: 'Delete Initial Uploaded Documents',
                                                            url: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/documents`,
                                                            changes: '',
                                                            details: apiCryptography.encrypt(
                                                                `{Data: 'referenceNumber=${state.userInfo.referenceNumber}&requestor=CLIENT&documentID=${savedDoc.documentID}'}`
                                                            ),
                                                            callingMethodName: 'DELETE',
                                                            refno: state.userInfo.referenceNumber.substring(10, 17),
                                                            ipAdd: window.localStorage.getItem('LOCALIP') || '',
                                                        };

                                                        Log(LogItem);

                                                        ctr = ctr + 1;
                                                        if (
                                                            ctr === images.length ||
                                                            ctr === state.noOfRequiredDocs
                                                        ) {
                                                            addNoOfDeletedDocs(true);
                                                        }
                                                    } else if (res.data.errors) {
                                                        dispatch({
                                                            type: SET_ERRORS,
                                                            payload: 'errors',
                                                        });
                                                        //(res);
                                                        nextStep(2);
                                                    } else {
                                                        dispatch({
                                                            type: SET_ERRORS,
                                                            payload: 'errors',
                                                        });
                                                        //(res);

                                                        nextStep(2);
                                                    }
                                                } catch (error) {
                                                    nextStep(2);
                                                    dispatch({
                                                        type: SET_ERRORS,
                                                        payload: 'errors',
                                                    });
                                                }
                                            });
                                        } else {
                                            addNoOfDeletedDocs(true);
                                        }
                                    });
                                    //uploadDocuments();
                                } else {
                                    //(res);
                                    uploadDocuments();
                                }
                            } else if (res.data.errors) {
                                dispatch({
                                    type: SET_ERRORS,
                                    payload:
                                        res.data.errors[0].errorMessage ||
                                        res.data.errors[0].message,
                                });
                                //(res);
                                nextStep(2);
                                //dispatch({ type: SET_LOADING, loading: false });
                            } else {
                                nextStep(2);
                                dispatch({
                                    type: SET_ERRORS,
                                    payload:
                                        'Document upload is temporarily unavailable. Please try again later.',
                                });
                                //(res);
                                ////(error);
                            }
                        } else {
                            nextStep(2);
                            dispatch({
                                type: SET_ERRORS,
                                payload:
                                    'Document upload is temporarily unavailable. Please try again later.',
                            });
                            //(res);
                            ////(error);
                        }
                        resolve();
                    } catch (error) {
                        console.log(error);
                        nextStep(2);
                        dispatch({
                            type: SET_ERRORS,
                            payload:
                                'Document upload is temporarily unavailable. Please try again later.',
                        });
                        ////(res);
                        //(error);
                    }
                },
                (error) => {
                    nextStep(2);
                    dispatch({
                        type: SET_ERRORS,
                        payload:
                            'Document upload is temporarily unavailable. Please try again later.',
                    });
                    //(error);
                }
            );
        } catch (error) {
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload:
                    'Document upload is temporarily unavailable. Please try again later.',
            });
            ////(res);
            //(error);
        }
    };

    const RetryUpload = (res, ctr, tryNo) => {
        console.log(res);
        let processdFiles = ctr;
        let RetryDocument = [];

        if (state.uploadedDocuments.length === ctr) {
            addNoOfSubmittedDocs(ctr);
        }

        if (typeof res === "object" && res.length > 0) {
            if (tryNo <= 5) {
                console.log("retry count: " + tryNo)
                res.forEach(
                    async (doc, orderNumber) => {
                        const res = await APIRequest.POST(`api/MW/Callapi`, {
                            APIurl: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/documents/`,
                            APIdata: apiCryptography.encrypt(`{Data:
                            {
                                documentId: '${doc.documentId}',
                                file: '${doc.file}',
                                //front: '0',
                                referenceNumber: '${doc.referenceNumber}',
                                //level: '0',
                                documentType: '${doc.documentType}',
                                requestor: 'CLIENT',
                                fileExtension: '${doc.fileExtension}',
                                customerID: '${state.userInfo.customerId}',
                                orderNumber: '${doc.orderNumber}',
                            }}`),
                            APImethod: 'POST',
                            APIsystem: 'On-Boarding-Document-Upload',
                            APIreferenceno: doc.referenceNumber,
                            APIevent: 'Upload Client Documents',
                        });
                        try {
                            if (res.data.error) {
                                nextStep(2);
                                dispatch({
                                    type: SET_ERRORS,
                                    payload:
                                        'Document upload is temporarily unavailable. Please try again later.',
                                });
                            } else {
                                if (res.data !== '') {
                                    res.data = JSON.parse(apiCryptography.decrypt(res.data));
                                }
                            }
                            if (res.data.data) {

                                ctr = ctr + 1;
                                if (state.uploadedDocuments.length === ctr) {
                                    addNoOfSubmittedDocs(ctr);
                                }

                                processdFiles = processdFiles + 1;
                                if (state.uploadedDocuments.length === processdFiles) {
                                    RetryUpload(RetryDocument, ctr, tryNo + 1);
                                }

                            } else if (res.data.errors) {
                                if (
                                    res.data.errors[0].errorCode === '-900000' ||
                                    res.data.errors[0].code === '-900000'
                                ) {
                                    console.log("error 9000");
                                    RetryDocument.push({
                                        documentId: doc.documentId,
                                        file: doc.file,
                                        documentType: doc.documentType,
                                        referenceNumber: doc.referenceNumber,
                                        fileExtension: doc.fileExtension,
                                        customerID: state.userInfo.customerId,
                                        orderNumber: doc.orderNumber,
                                    });

                                    processdFiles = processdFiles + 1;
                                    if (state.uploadedDocuments.length === processdFiles) {
                                        RetryUpload(RetryDocument, ctr, tryNo + 1);
                                    }
                                } else {
                                    RetryDocument.push({
                                        documentId: doc.documentId,
                                        file: doc.file,
                                        documentType: doc.documentType,
                                        referenceNumber: doc.referenceNumber,
                                        fileExtension: doc.fileExtension,
                                        customerID: state.userInfo.customerId,
                                        orderNumber: doc.orderNumber,
                                    });

                                    processdFiles = processdFiles + 1;
                                    if (state.uploadedDocuments.length === processdFiles) {
                                        RetryUpload(RetryDocument, ctr, tryNo + 1);
                                    }

                                    //dispatch({
                                    //    type: SET_ERRORS,
                                    //    payload: 'error',
                                    //});
                                    //nextStep(2);
                                }

                            } else {
                                RetryDocument.push({
                                    documentId: doc.documentId,
                                    file: doc.file,
                                    documentType: doc.documentType,
                                    referenceNumber: doc.referenceNumber,
                                    fileExtension: doc.fileExtension,
                                    customerID: state.userInfo.customerId,
                                    orderNumber: doc.orderNumber,
                                });

                                processdFiles = processdFiles + 1;
                                if (state.uploadedDocuments.length === processdFiles) {
                                    RetryUpload(RetryDocument, ctr, tryNo + 1);
                                }

                                //dispatch({
                                //    type: SET_ERRORS,
                                //    payload: 'error',
                                //});
                                //nextStep(2);
                            }
                        } catch (error) {
                            console.log("error retry trycatch");
                            RetryDocument.push({
                                documentId: doc.documentId,
                                file: doc.file,
                                documentType: doc.documentType,
                                referenceNumber: doc.referenceNumber,
                                fileExtension: doc.fileExtension,
                                customerID: state.userInfo.customerId,
                                orderNumber: doc.orderNumber,
                            });

                            processdFiles = processdFiles + 1;
                            if (state.uploadedDocuments.length === processdFiles) {
                                RetryUpload(RetryDocument, ctr, tryNo + 1);
                            }

                            //nextStep(2);
                            //dispatch({
                            //    type: SET_ERRORS,
                            //    payload: 'error',
                            //});
                        }
                    },
                    (error) => {
                        console.log("error retry async");
                        // RetryDocument.push({
                        //     documentId: doc.documentId,
                        //     file: doc.file,
                        //     documentType: doc.documentType,
                        //     referenceNumber: doc.referenceNumber,
                        //     fileExtension: doc.fileExtension,
                        //     customerID: state.userInfo.customerId,
                        //     orderNumber: doc.orderNumber,
                        // });

                        processdFiles = processdFiles + 1;
                        if (state.uploadedDocuments.length === processdFiles) {
                            RetryUpload(RetryDocument, ctr, tryNo + 1);
                        }

                        //nextStep(2);
                        //dispatch({
                        //    type: SET_ERRORS,
                        //    payload: 'error',
                        //});
                    }
                );
            }
            else {
                dispatch({
                    type: SET_ERRORS,
                    payload: 'error',
                });
                nextStep(2);
            }
        }
        //else {
        //    //Acknowledgement
        //    addNoOfSubmittedDocs(ctr);
        //}
    }

    const uploadDocuments = () => {
        //try {
        let ctr = 0;
        let RetryDocument = [];
        let processdFiles = 0;
        state.uploadedDocuments.forEach(
            async (doc, orderNumber) => {
                const res = await APIRequest.POST(`api/MW/Callapi`, {
                    APIurl: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/documents/`,
                    APIdata: apiCryptography.encrypt(`{Data:
                            {
                                documentId: '${doc.documentId}',
                                file: '${doc.file}',
                                //front: '0',
                                referenceNumber: '${doc.referenceNumber}',
                                //level: '0',
                                documentType: '${doc.documentType}',
                                requestor: 'CLIENT',
                                fileExtension: '${doc.fileExtension}',
                                customerID: '${state.userInfo.customerId}',
                                orderNumber: '${doc.orderNumber}',
                            }}`),
                    APImethod: 'POST',
                    APIsystem: 'On-Boarding-Document-Upload',
                    APIreferenceno: doc.referenceNumber,
                    APIevent: 'Upload Client Documents',
                });
                try {
                    if (res.data.error) {
                        nextStep(2);
                        dispatch({
                            type: SET_ERRORS,
                            payload:
                                'Document upload is temporarily unavailable. Please try again later.',
                        });
                    } else {
                        if (res.data !== '') {
                            res.data = JSON.parse(apiCryptography.decrypt(res.data));
                        }
                    }
                    if (res.data.data) {

                        let LogItem = {
                            screen: 'On-Boarding-Document-Upload',
                            activity: 'Upload Client Documents',
                            url: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_API_OB_LINK}/documents/`,
                            changes: '',
                            details: apiCryptography.encrypt(`{Data:
                                            {
                                                documentId: '${doc.documentId}',
                                                file: '${doc.file}',
                                                //front: '0',
                                                referenceNumber: '${doc.referenceNumber}',
                                                //level: '0',
                                                documentType: '${doc.documentType}',
                                                requestor: 'CLIENT',
                                                fileExtension: '${doc.fileExtension}',
                                                customerID: '${state.userInfo.customerId}',
                                                orderNumber: '${doc.orderNumber}',
                                            }}`),
                            callingMethodName: 'POST',
                            refno: doc.referenceNumber.substring(10, 17),
                            ipAdd: window.localStorage.getItem('LOCALIP') || '',
                        };
                        Log(LogItem);

                        ctr = ctr + 1;
                        if (state.uploadedDocuments.length === ctr) {
                            addNoOfSubmittedDocs(ctr);
                        }

                        processdFiles = processdFiles + 1;
                        if (state.uploadedDocuments.length === processdFiles) {
                            RetryUpload(RetryDocument, ctr, 1);
                        }

                        nextStep(1);

                    } else if (res.data.errors) {
                        // //HEREEEEEEEEEEEE
                        if (
                            res.data.errors[0].errorCode === '-900000' ||
                            res.data.errors[0].code === '-900000'
                        ) {
                            console.log("error 9000");
                            RetryDocument.push({
                                documentId: doc.documentId,
                                file: doc.file,
                                documentType: doc.documentType,
                                referenceNumber: doc.referenceNumber,
                                fileExtension: doc.fileExtension,
                                customerID: state.userInfo.customerId,
                                orderNumber: doc.orderNumber,
                            });

                            processdFiles = processdFiles + 1;
                            if (state.uploadedDocuments.length === processdFiles) {
                                RetryUpload(RetryDocument, ctr, 1);
                            }
                        } else {
                            RetryDocument.push({
                                documentId: doc.documentId,
                                file: doc.file,
                                documentType: doc.documentType,
                                referenceNumber: doc.referenceNumber,
                                fileExtension: doc.fileExtension,
                                customerID: state.userInfo.customerId,
                                orderNumber: doc.orderNumber,
                            });

                            processdFiles = processdFiles + 1;
                            if (state.uploadedDocuments.length === processdFiles) {

                                RetryUpload(RetryDocument, ctr, 1);
                            }

                            //dispatch({
                            //    type: SET_ERRORS,
                            //    payload: 'error',
                            //});
                            //nextStep(2);
                        }

                    } else {
                        RetryDocument.push({
                            documentId: doc.documentId,
                            file: doc.file,
                            documentType: doc.documentType,
                            referenceNumber: doc.referenceNumber,
                            fileExtension: doc.fileExtension,
                            customerID: state.userInfo.customerId,
                            orderNumber: doc.orderNumber,
                        });

                        processdFiles = processdFiles + 1;
                        if (state.uploadedDocuments.length === processdFiles) {

                            RetryUpload(RetryDocument, ctr, 1);
                        }
                        //dispatch({
                        //    type: SET_ERRORS,
                        //    payload: 'error',
                        //});
                        //nextStep(2);
                    }
                } catch (error) {
                    console.log("error trycatch");
                    RetryDocument.push({
                        documentId: doc.documentId,
                        file: doc.file,
                        documentType: doc.documentType,
                        referenceNumber: doc.referenceNumber,
                        fileExtension: doc.fileExtension,
                        customerID: state.userInfo.customerId,
                        orderNumber: doc.orderNumber,
                    });

                    processdFiles = processdFiles + 1;
                    if (state.uploadedDocuments.length === processdFiles) {
                        RetryUpload(RetryDocument, ctr, 1);
                    }

                    //nextStep(2);
                    //dispatch({
                    //    type: SET_ERRORS,
                    //    payload: 'error',
                    //});
                }
            },
            (error) => {
                console.log("error async");
                // RetryDocument.push({
                //     documentId: doc.documentId,
                //     file: doc.file,
                //     documentType: doc.documentType,
                //     referenceNumber: doc.referenceNumber,
                //     fileExtension: doc.fileExtension,
                //     customerID: state.userInfo.customerId,
                //     orderNumber: doc.orderNumber,
                // });

                processdFiles = processdFiles + 1;
                if (state.uploadedDocuments.length === processdFiles) {
                    RetryUpload(RetryDocument, ctr, 1);
                }
                //nextStep(2);
                //dispatch({
                //    type: SET_ERRORS,
                //    payload: 'error',
                //});
            }
        );
        //} catch (error) {
        //    nextStep(2);
        //    dispatch({
        //        type: SET_ERRORS,
        //        payload: 'error',
        //    });
        //}
    };

    const submitDocuments = async (refNo, customerId, status) => {
        const today = new Date();
        var months = [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
        ];
        function formatAMPM(date) {
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var seconds = date.getSeconds();
            var ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12;
            minutes = minutes < 10 ? '0' + minutes : minutes;

            var strTime = hours + ':' + minutes + ':' + seconds + ampm;
            return strTime;
        }

        setLoading();
        try {
            await APIRequest.POST(`api/MW/Callapi`, {
                APIurl: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_ONBORDING_ENDPOINT_ONE}/onboarding/applications/status/update`,
                APIdata: apiCryptography.encrypt(`{Data: {
                        referenceNumber: '${refNo}',
                        status: 30,
                        processType: 0,
                        appLevel: 3,
                        statusDate: '${months[today.getMonth()]}/${today.getDate()}/${today.getFullYear()}  ${formatAMPM(new Date())}',
                        statusDescription: 'Uploaded documents', 
                        remarks: 'Uploaded documents',
                        createdBy: 'CLIENT',
                    }}`),
                APImethod: 'POST',
                APIsystem: 'On-Boarding-Update-Status',
                APIreferenceno: refNo,
                APIevent: 'Update Customer Status',
            }).then(
                (result) => {
                    var res = result;
                    console.log(res);
                    if (res !== undefined) {
                        ////////////////////
                        if (res.data.error) {
                            console.log("Status Update data.Error");
                            nextStep(2);
                            dispatch({
                                type: SET_ERRORS,
                                payload:
                                    'Document upload is temporarily unavailable. Please try again later.',
                            });
                        } else {
                            if (res.data !== '') {
                                res.data = JSON.parse(apiCryptography.decrypt(res.data));

                                if (res.data.data) {
                                    deleteForCompliance(refNo);
                                    emailNotification();
                                    smsNotification();
                                    checkDoneProcess(1);
                                } else {
                                    console.log("Status Update Res.data.data");
                                    nextStep(2);
                                }
                            }
                        }
                        ////////////////
                    } else {
                        console.log("Status Update Res Undefine");
                        nextStep(2);
                        dispatch({
                            type: SET_ERRORS,
                            payload:
                                'Document upload is temporarily unavailable. Please try again later.',
                        });
                        //(res);
                        ////(error);
                    }
                },
                (error) => {
                    console.log("Status Update Error");
                    nextStep(2);
                    dispatch({
                        type: SET_ERRORS,
                        payload:
                            'Document upload is temporarily unavailable. Please try again later.',
                    });
                    //(error);
                }
            );

            // await deleteDocuments().then(() => {
            //   uploadDocuments();
            // });
        } catch (error) {
            console.log(error);
            console.log("Status Update Catch");
            nextStep(2);
            dispatch({
                type: SET_ERRORS,
                payload:
                    'Document upload is temporarily unavailable. Please try again later.',
            });
            ////(res);
            //(error);
        }
    };

    const deleteForCompliance = (refNo) => {
        try {
            APIRequest.POST(
                `api/MW/Callapi`,
                {
                    APIurl: `${process.env.REACT_APP_API_LINK}/${process.env.REACT_APP_ONBORDING_ENDPOINT_ONE}/onboarding/applications/for-compliance`,
                    APImethod: 'DELETE',
                    APIData: apiCryptography.encrypt(`{Data: 'referencenumber=${refNo}'}`),
                    APIsystem: 'On-Boarding-Document-Upload',
                    APIreferenceno: refNo,
                    APIevent: 'DELETE For Compliance Requirements',
                },
                state.token,
                setToken,
                state.userInfo.sessionId
            ).then(
                (res) => {
                    //checkDoneProcess();
                },
                (error) => {
                }
            );
        } catch (error) { }
    };

    const smsNotification = () => {
        const today = new Date();
        var months = [
            '01',
            '02',
            '03',
            '04',
            '05',
            '06',
            '07',
            '08',
            '09',
            '10',
            '11',
            '12',
        ];

        try {
            APIRequest.POST(`api/MW/Callapi`, {
                APIurl: `${process.env.REACT_APP_API_LINK}/notification/sms`,
                APIdata: apiCryptography.encrypt(`{Data:  {
                        mobileNumber: '${state.userInfo.mobileNumber
                    }',                 
                        message: 'This is to acknowledge receipt of the required documents for your PSBank Online Account Application on ${months[today.getMonth()]}-${today.getDate()}-${today.getFullYear()} (Ref.No.${state.userInfo.referenceNumber}). Please expect to receive notification on the status of your application soon. If you did not initiate this application, call(02) 8845 - 8888. Thank you.',
                        subCategory: 'Notif',
                    }}`),
                APImethod: 'POST',
                APIsystem: 'On-Boarding-Document-Upload-Send-SMS',
                APIreferenceno: state.userInfo.referenceNumber,
                APIevent: 'Send SMS Notification',
            }).then((res) => {
                //(res);
                //checkDoneProcess(ctr);
                let LogItem = {
                    screen: 'On-Boarding-Document-Upload-Send-SMS',
                    activity: 'Send SMS Notification',
                    url: `${process.env.REACT_APP_API_LINK}/notification/sms`,
                    changes: '',
                    details: apiCryptography.encrypt(`{Data:  {
                        mobileNumber: '${state.userInfo.mobileNumber
                        }',                 
                        message: 'This is to acknowledge receipt of the required documents for your PSBank Online Account Application on ${months[today.getMonth()]}-${today.getDate()}-${today.getFullYear()} (Ref.No.${state.userInfo.referenceNumber}). Please expect to receive notification on the status of your application soon. If you did not initiate this application, call(02) 8845 - 8888. Thank you.',
                        subCategory: 'Notif',
                    }}`),
                    callingMethodName: 'POST',
                    refno: state.userInfo.referenceNumber.substring(10, 17),
                    ipAdd: window.localStorage.getItem('LOCALIP') || '',
                };

                Log(LogItem);
            });
        } catch (e) {
            //(e);
        }
    };

    const emailNotification = () => {
        console.log("Email");
        const today = new Date();
        var months = [
            '01',
            '02',
            '03',
            '04',
            '05',
            '06',
            '07',
            '08',
            '09',
            '10',
            '11',
            '12',
        ];
        let x = 1;
        var listOfDocs = [];
        for (let i = 0; i < state.complianceDocuments.documents.length; i++) {
            listOfDocs.push(
                x.toString() +
                '. ' +
                state.complianceDocuments.documents[i].description.replace("'", '') +
                '\r\n'
            );

            x++;
            var stringmo = listOfDocs.toString();

            //(stringmo.replace(/,/g, '\n'));
        }
        try {
            console.log(apiCryptography.encrypt(`{Data:  {
                        sender: 'onlinebanking@psbank.com.ph',
                        recipient: '${state.userInfo.emailAddress}',
                        subject: 'PSBank - Online Account Application',
                        parameters: {
                            notificationKey: 'onboarding.for.compliance.acknowledge.email',
                            referenceNumber: '${state.userInfo.referenceNumber}',
                            param: {
                                '{LAST_NAME}': '${state.userInfo.lastName}',
                                '{REFERENCE_NUMBER}': '${state.userInfo.referenceNumber}',
                                '{DOCUMENTS}': '${stringmo.replace(/,/g, '\n')}',
                                '{TRANSACTION_DATE}': '${months[today.getMonth()]}-${today.getDate()}-${today.getFullYear()}'
                            }
                        },
                        isBodyHtml: true,
                    }}`));
            APIRequest.POST(
                `api/MW/Callapi`,
                {
                    APIurl: `${process.env.REACT_APP_API_LINK}/notification/email`,
                    APIdata: apiCryptography.encrypt(`{Data:  {
                        sender: 'onlinebanking@psbank.com.ph',
                        recipient: '${state.userInfo.emailAddress}',
                        subject: 'PSBank - Online Account Application',
                        parameters: {
                            notificationKey: 'onboarding.for.compliance.acknowledge.email',
                            referenceNumber: '${state.userInfo.referenceNumber}',
                            param: {
                                '{LAST_NAME}': '${state.userInfo.lastName}',
                                '{REFERENCE_NUMBER}': '${state.userInfo.referenceNumber}',
                                '{DOCUMENTS}': '${stringmo.replace(/,/g, '\n')}',
                                '{TRANSACTION_DATE}': '${months[today.getMonth()]}-${today.getDate()}-${today.getFullYear()}'
                            }
                        },
                        isBodyHtml: true,
                    }}`),
                    APImethod: 'POST',
                    APIsystem: 'On-Boarding-Document-Upload-Send-Email',
                    APIreferenceno: state.userInfo.referenceNumber,
                    APIevent: 'Send Email Notification',
                },
                state.token,
                setToken,
                state.userInfo.sessionId
            ).then((res) => {

                //checkDoneProcess(ctr);
                let LogItem = {
                    screen: 'On - Boarding - Document - Upload - Send - Email',
                    activity: 'Send Email Notification',
                    url: `${process.env.REACT_APP_API_LINK}/notification/email`,
                    changes: '',
                    details: apiCryptography.encrypt(`{Data:  {
                        sender: 'onlinebanking@psbank.com.ph',
                        recipient: '${state.userInfo.emailAddress}',
                        subject: 'PSBank - Online Account Application',
                        parameters: {
                            notificationKey: 'onboarding.for.compliance.acknowledge.email',
                            referenceNumber: '${state.userInfo.referenceNumber}',
                            param: {
                                '{LAST_NAME}': '${state.userInfo.lastName}',
                                '{REFERENCE_NUMBER}': '${state.userInfo.referenceNumber}',
                                '{DOCUMENTS}': '${stringmo.replace(/,/g, '\n')}',
                                '{TRANSACTION_DATE}': '${months[today.getMonth()]}-${today.getDate()}-${today.getFullYear()}'
                            }
                        },
                        isBodyHtml: true,
                    }}`),
                    callingMethodName: 'POST',
                    refno: state.userInfo.referenceNumber.substring(10, 17),
                    ipAdd: window.localStorage.getItem('LOCALIP') || '',
                };

                Log(LogItem);
            });
        } catch (e) {
            console.log(e);
            //(e);
        }
    };

    const clearErrors = () => {
        dispatch({
            type: SET_ERRORS,
            payload: null,
        });
    };

    const clearNotifications = () => {
        dispatch({
            type: SET_NOTIFICATIONS,
            payload: null,
        });
    };

    const nextStep = (step) => {
        dispatch({
            type: NEXT_STEP,
            payload: step,
        });
    };
    //(nextStep);
    //(state.step);
    const addNoOfSubmittedDocs = (noDocs) => {
        dispatch({
            type: ADD_NO_SUBMITTED_DOCUMENTS,
            payload: noDocs,
        });
    };

    const addNoOfDeletedDocs = (delDocs) => {
        dispatch({
            type: ADD_NO_DELETED_DOCUMENTS,
            payload: delDocs,
        });
    };

    const setLoading = (loading) =>
        dispatch({ type: SET_LOADING, payload: loading });

    const setToken = (token) => {
        dispatch({
            type: SET_TOKEN,
            payload: token,
        });
    };

    const checkDoneProcess = (val) => {
        dispatch({
            type: DONE_PROCESS,
            payload: val,
        });
    };

    return (
        <documentUploadContext.Provider
            value={{
                userInfo: state.userInfo,
                errors: state.errors,
                loading: state.loading,
                requirements: state.requirements,
                step: state.step,
                documents: state.documents,
                uploadedDocuments: state.uploadedDocuments,
                notifications: state.notifications,
                complianceDocuments: state.complianceDocuments,
                noOfUploadedDocs: state.noOfUploadedDocs,
                noOfRequiredDocs: state.noOfRequiredDocs,
                noOfSubmittedDocs: state.noOfSubmittedDocs,
                doneProcess: state.doneProcess,
                delDocs: state.delDocs,
                customerId: state.customerId,
                setUserInfo,
                clearErrors,
                clearNotifications,
                validateOTP,
                nextStep,
                requestForOTP,
                uploadDocument,
                submitDocuments,
                getComplianceDocuments,
                addNoOfSubmittedDocs,
                checkDoneProcess,
                uploadDocuments,
                deleteDocuments,
                deleteForCompliance,
                emailNotification,
                addNoOfDeletedDocs,
                CheckifSoftLock,
                getApplicationDetails,
                applicationDetails: state.applicationDetails,
                otpRequest,
                videoCallSchedule: state.videoCallSchedule,
                getVideoCallSchedule,
                setVideoCallSchedule,
                selectedVideoCallSchedule: state.selectedVideoCallSchedule,
                submitVideoCallSchedule,
                setDisplayVideoCallSchedule,
                selectedDisplayVideoCallSchedule: state.selectedDisplayVideoCallSchedule,
                setAtmCardNumberDetails,
                cardValidationMobileNumber,
                atmCardNumberDetails: state.atmCardNumberDetails,
                atmCardDetailsBirthday: state.atmCardDetailsBirthday,
                atmCardValidation: state.atmCardValidation,
                atmCardActivationSubmit: state.atmCardActivationSubmit,
                changePinSubmit: state.changePinSubmit,
                nominatePin,
                oldPin,
                submitNominatedPin,
                submitNewNominatedPin,
                generatePreparedPin,
                generatePreparedPan,
                validateOldPinSubmit,
                setNominatedPin: state.setNominatedPin,
                setOldPin: state.setOldPin,
                getCardSessionValidation,
                cardSessionValidation: state.cardSessionValidation,
                setIncorrectLinkError,
                localIP: state.localIP,
                oldPinValidation: state.oldPinValidation,
                activationCodeValidation: activationCodeValidation,
                referenceCode: state.referenceCode
            }}
        >
            {props.children}
        </documentUploadContext.Provider>
    );
};

export default DocumentUploadState;
